/**
 * Scene manifest for the web previewer.
 * AUTO-GENERATED - Do not edit manually. Run: pnpm generate:fixtures
 */

export interface Fixture {
  name: string;
  file: string;
  category: string;
  /** public/fixtures subtree the scene's res:// namespace maps onto ('' = root). */
  root?: string;
}

export const fixtures: Fixture[] = [
  {
    "name": "Child_animated_player",
    "file": "child_animated_player.tscn",
    "category": "Other"
  },
  {
    "name": "Child_cube",
    "file": "child_cube.tscn",
    "category": "Other"
  },
  {
    "name": "Child_sphere",
    "file": "child_sphere.tscn",
    "category": "Other"
  },
  {
    "name": "Complex 2d Gui",
    "file": "complex-2d-gui.tscn",
    "category": "Other"
  },
  {
    "name": "Nested Leaf Orange Sphere",
    "file": "nested-leaf-orange-sphere.tscn",
    "category": "Other"
  },
  {
    "name": "Nested Middle Blue Box",
    "file": "nested-middle-blue-box.tscn",
    "category": "Other"
  },
  {
    "name": "Nested Top Green Cylinder",
    "file": "nested-top-green-cylinder.tscn",
    "category": "Other"
  },
  {
    "name": "Test Missing External Scene",
    "file": "test-missing-external-scene.tscn",
    "category": "Other"
  },
  {
    "name": "Test Missing Material",
    "file": "test-missing-material.tscn",
    "category": "Other"
  },
  {
    "name": "Test Missing Texture",
    "file": "test-missing-texture.tscn",
    "category": "Other"
  },
  {
    "name": "Test Multiple Meshes Shared Texture",
    "file": "test-multiple-meshes-shared-texture.tscn",
    "category": "Other"
  },
  {
    "name": "Test Nested Leaf",
    "file": "test-nested-leaf.tscn",
    "category": "Other"
  },
  {
    "name": "Test Nested Middle",
    "file": "test-nested-middle.tscn",
    "category": "Other"
  },
  {
    "name": "Test Nested Top",
    "file": "test-nested-top.tscn",
    "category": "Other"
  },
  {
    "name": "Accept Dialog",
    "file": "unit-accept-dialog.tscn",
    "category": "Other"
  },
  {
    "name": "Aim Modifier 3d",
    "file": "unit-aim-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Alpha Antialiasing One Sample",
    "file": "unit-alpha-antialiasing-one-sample.tscn",
    "category": "Other"
  },
  {
    "name": "Animatable Body 2d",
    "file": "unit-animatable-body-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Animatable Body 3d",
    "file": "unit-animatable-body-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Animated Sprite 3d",
    "file": "unit-animated-sprite-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Animatedsprite2d Atlas",
    "file": "unit-animatedsprite2d-atlas.tscn",
    "category": "Other"
  },
  {
    "name": "Animatedsprite2d Texture Filter Inherited",
    "file": "unit-animatedsprite2d-texture-filter-inherited.tscn",
    "category": "Other"
  },
  {
    "name": "Animatedsprite2d Tres",
    "file": "unit-animatedsprite2d-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Animatedsprite2d Untextured",
    "file": "unit-animatedsprite2d-untextured.tscn",
    "category": "Other"
  },
  {
    "name": "Animatedsprite2d",
    "file": "unit-animatedsprite2d.tscn",
    "category": "Other"
  },
  {
    "name": "Animation 3d Transform Tracks",
    "file": "unit-animation-3d-transform-tracks.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player 2d",
    "file": "unit-animation-player-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player Autoplay",
    "file": "unit-animation-player-autoplay.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player Decal",
    "file": "unit-animation-player-decal.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player Libraries",
    "file": "unit-animation-player-libraries.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player Method Track",
    "file": "unit-animation-player-method-track.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player Parent Relative",
    "file": "unit-animation-player-parent-relative.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player Sprite Frame",
    "file": "unit-animation-player-sprite-frame.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Player",
    "file": "unit-animation-player.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Tree State Machine",
    "file": "unit-animation-tree-state-machine.tscn",
    "category": "Other"
  },
  {
    "name": "Animation Tree Stateless",
    "file": "unit-animation-tree-stateless.tscn",
    "category": "Other"
  },
  {
    "name": "Animationtree Blend",
    "file": "unit-animationtree-blend.tscn",
    "category": "Other"
  },
  {
    "name": "Animationtree Instanced Anim Player",
    "file": "unit-animationtree-instanced-anim-player.tscn",
    "category": "Other"
  },
  {
    "name": "Area2d",
    "file": "unit-area2d.tscn",
    "category": "Other"
  },
  {
    "name": "Aspect Ratio Container Rtl",
    "file": "unit-aspect-ratio-container-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Aspect Ratio Container",
    "file": "unit-aspect-ratio-container.tscn",
    "category": "Other"
  },
  {
    "name": "Atlastexture Normal Mipmap",
    "file": "unit-atlastexture-normal-mipmap.tscn",
    "category": "Other"
  },
  {
    "name": "Back Buffer Copy",
    "file": "unit-back-buffer-copy.tscn",
    "category": "Other"
  },
  {
    "name": "Base Button",
    "file": "unit-base-button.tscn",
    "category": "Other"
  },
  {
    "name": "Binary Resource Mesh",
    "file": "unit-binary-resource-mesh.tscn",
    "category": "Other"
  },
  {
    "name": "Bone 2d",
    "file": "unit-bone-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Bone Attachment 3d Follow",
    "file": "unit-bone-attachment-3d-follow.tscn",
    "category": "Other"
  },
  {
    "name": "Bone Attachment 3d",
    "file": "unit-bone-attachment-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Bone Constraint 3d",
    "file": "unit-bone-constraint-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Bone Twist Disperser 3d",
    "file": "unit-bone-twist-disperser-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Bone2d Rig",
    "file": "unit-bone2d-rig.tscn",
    "category": "Other"
  },
  {
    "name": "Bool Numeric Slots",
    "file": "unit-bool-numeric-slots.tscn",
    "category": "Other"
  },
  {
    "name": "Canvas Edge On Pixel Centre",
    "file": "unit-canvas-edge-on-pixel-centre.tscn",
    "category": "Other"
  },
  {
    "name": "Canvas Group",
    "file": "unit-canvas-group.tscn",
    "category": "Other"
  },
  {
    "name": "Canvas Light Render Budget",
    "file": "unit-canvas-light-render-budget.tscn",
    "category": "Other"
  },
  {
    "name": "Canvas Modulate",
    "file": "unit-canvas-modulate.tscn",
    "category": "Other"
  },
  {
    "name": "Canvas Root Visibility",
    "file": "unit-canvas-root-visibility.tscn",
    "category": "Other"
  },
  {
    "name": "Ccdik 3d",
    "file": "unit-ccdik-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Characterbody2d",
    "file": "unit-characterbody2d.tscn",
    "category": "Other"
  },
  {
    "name": "Characterbody3d",
    "file": "unit-characterbody3d.tscn",
    "category": "Other"
  },
  {
    "name": "Check Box Fitted Icon",
    "file": "unit-check-box-fitted-icon.tscn",
    "category": "Other"
  },
  {
    "name": "Check Button Half Pixel Icon",
    "file": "unit-check-button-half-pixel-icon.tscn",
    "category": "Other"
  },
  {
    "name": "Check Button Rtl",
    "file": "unit-check-button-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Check Button",
    "file": "unit-check-button.tscn",
    "category": "Other"
  },
  {
    "name": "Code Edit Delimiters",
    "file": "unit-code-edit-delimiters.tscn",
    "category": "Other"
  },
  {
    "name": "Code Edit Guidelines",
    "file": "unit-code-edit-guidelines.tscn",
    "category": "Other"
  },
  {
    "name": "Code Edit Rtl",
    "file": "unit-code-edit-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Code Edit Syntax Highlighter",
    "file": "unit-code-edit-syntax-highlighter.tscn",
    "category": "Other"
  },
  {
    "name": "Code Edit",
    "file": "unit-code-edit.tscn",
    "category": "Other"
  },
  {
    "name": "Coin Glow",
    "file": "unit-coin-glow.tscn",
    "category": "Other"
  },
  {
    "name": "Color Picker Button",
    "file": "unit-color-picker-button.tscn",
    "category": "Other"
  },
  {
    "name": "Color Picker Rtl",
    "file": "unit-color-picker-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Color Picker",
    "file": "unit-color-picker.tscn",
    "category": "Other"
  },
  {
    "name": "Cone Twist Joint 3d",
    "file": "unit-cone-twist-joint-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Confirmation Dialog",
    "file": "unit-confirmation-dialog.tscn",
    "category": "Other"
  },
  {
    "name": "Container",
    "file": "unit-container.tscn",
    "category": "Other"
  },
  {
    "name": "Convert Transform Modifier 3d",
    "file": "unit-convert-transform-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Copy Transform Modifier 3d Ribbon",
    "file": "unit-copy-transform-modifier-3d-ribbon.tscn",
    "category": "Other"
  },
  {
    "name": "Copy Transform Modifier 3d",
    "file": "unit-copy-transform-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Cpu Particles 3d",
    "file": "unit-cpu-particles-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Color Ramp",
    "file": "unit-cpuparticles2d-color-ramp.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Crossed Range",
    "file": "unit-cpuparticles2d-crossed-range.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Curves",
    "file": "unit-cpuparticles2d-curves.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Directed Points",
    "file": "unit-cpuparticles2d-directed-points.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Emission Shapes",
    "file": "unit-cpuparticles2d-emission-shapes.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Local Coords",
    "file": "unit-cpuparticles2d-local-coords.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Not Emitting",
    "file": "unit-cpuparticles2d-not-emitting.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Ring",
    "file": "unit-cpuparticles2d-ring.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Split Scale",
    "file": "unit-cpuparticles2d-split-scale.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Unpreprocessed",
    "file": "unit-cpuparticles2d-unpreprocessed.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d Unseeded",
    "file": "unit-cpuparticles2d-unseeded.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles2d",
    "file": "unit-cpuparticles2d.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles3d Directed Points",
    "file": "unit-cpuparticles3d-directed-points.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles3d Gizmo",
    "file": "unit-cpuparticles3d-gizmo.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles3d Row",
    "file": "unit-cpuparticles3d-row.tscn",
    "category": "Other"
  },
  {
    "name": "Cpuparticles3d Triplanar Points",
    "file": "unit-cpuparticles3d-triplanar-points.tscn",
    "category": "Other"
  },
  {
    "name": "Damped Spring Joint 2d",
    "file": "unit-damped-spring-joint-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Atlas Texture",
    "file": "unit-decal-atlas-texture.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Cull Mask",
    "file": "unit-decal-cull-mask.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Emission Map",
    "file": "unit-decal-emission-map.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Gradienttexture",
    "file": "unit-decal-gradienttexture.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Mipmap Import",
    "file": "unit-decal-mipmap-import.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Normal Map",
    "file": "unit-decal-normal-map.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Orm Map",
    "file": "unit-decal-orm-map.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Roughness Receiver",
    "file": "unit-decal-roughness-receiver.tscn",
    "category": "Other"
  },
  {
    "name": "Decal Triangulation",
    "file": "unit-decal-triangulation.tscn",
    "category": "Other"
  },
  {
    "name": "Decal",
    "file": "unit-decal.tscn",
    "category": "Other"
  },
  {
    "name": "Depth Fog Aerial Sky",
    "file": "unit-depth-fog-aerial-sky.tscn",
    "category": "Other"
  },
  {
    "name": "Depth Fog Orthographic",
    "file": "unit-depth-fog-orthographic.tscn",
    "category": "Other"
  },
  {
    "name": "Depth Fog",
    "file": "unit-depth-fog.tscn",
    "category": "Other"
  },
  {
    "name": "Directional Light 2d",
    "file": "unit-directional-light-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Directional Light 3d",
    "file": "unit-directional-light-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Directional Light Limit",
    "file": "unit-directional-light-limit.tscn",
    "category": "Other"
  },
  {
    "name": "Directional Light Sky Mode",
    "file": "unit-directional-light-sky-mode.tscn",
    "category": "Other"
  },
  {
    "name": "Directional Shadow Fade",
    "file": "unit-directional-shadow-fade.tscn",
    "category": "Other"
  },
  {
    "name": "Directional Shadow Shared Atlas",
    "file": "unit-directional-shadow-shared-atlas.tscn",
    "category": "Other"
  },
  {
    "name": "Directional Shadow Splits",
    "file": "unit-directional-shadow-splits.tscn",
    "category": "Other"
  },
  {
    "name": "Directionallight2d Canvas Layer Cap",
    "file": "unit-directionallight2d-canvas-layer-cap.tscn",
    "category": "Other"
  },
  {
    "name": "Directionallight2d Normal Map",
    "file": "unit-directionallight2d-normal-map.tscn",
    "category": "Other"
  },
  {
    "name": "Directionallight2d Render Budget",
    "file": "unit-directionallight2d-render-budget.tscn",
    "category": "Other"
  },
  {
    "name": "Directionallight2d Shadow Pcf5",
    "file": "unit-directionallight2d-shadow-pcf5.tscn",
    "category": "Other"
  },
  {
    "name": "Directionallight2d Shadow",
    "file": "unit-directionallight2d-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Directionallight2d",
    "file": "unit-directionallight2d.tscn",
    "category": "Other"
  },
  {
    "name": "Environment Adjustments",
    "file": "unit-environment-adjustments.tscn",
    "category": "Other"
  },
  {
    "name": "Environment Linear Exposure",
    "file": "unit-environment-linear-exposure.tscn",
    "category": "Other"
  },
  {
    "name": "Environment Reflected Source Disabled Probe",
    "file": "unit-environment-reflected-source-disabled-probe.tscn",
    "category": "Other"
  },
  {
    "name": "Environment Reflected Source Disabled",
    "file": "unit-environment-reflected-source-disabled.tscn",
    "category": "Other"
  },
  {
    "name": "Environment Reflected Source Sky",
    "file": "unit-environment-reflected-source-sky.tscn",
    "category": "Other"
  },
  {
    "name": "Environment Sky Tonemap",
    "file": "unit-environment-sky-tonemap.tscn",
    "category": "Other"
  },
  {
    "name": "Environment Ssr",
    "file": "unit-environment-ssr.tscn",
    "category": "Other"
  },
  {
    "name": "Escaped Heading Hud",
    "file": "unit-escaped-heading-hud.tscn",
    "category": "Other"
  },
  {
    "name": "Escaped Heading Inner",
    "file": "unit-escaped-heading-inner.tscn",
    "category": "Other"
  },
  {
    "name": "Escaped Heading Player",
    "file": "unit-escaped-heading-player.tscn",
    "category": "Other"
  },
  {
    "name": "Fabrik 3d",
    "file": "unit-fabrik-3d.tscn",
    "category": "Other"
  },
  {
    "name": "File Dialog",
    "file": "unit-file-dialog.tscn",
    "category": "Other"
  },
  {
    "name": "Flow Container Rtl Reverse Fill",
    "file": "unit-flow-container-rtl-reverse-fill.tscn",
    "category": "Other"
  },
  {
    "name": "Flow Container Rtl",
    "file": "unit-flow-container-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Flow Container",
    "file": "unit-flow-container.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume Density Half Tres",
    "file": "unit-fog-volume-density-half-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume Density Image",
    "file": "unit-fog-volume-density-image.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume Density Noise Tres",
    "file": "unit-fog-volume-density-noise-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume Density Ramp Tres",
    "file": "unit-fog-volume-density-ramp-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume Density Volume Tres",
    "file": "unit-fog-volume-density-volume-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume Shader Material",
    "file": "unit-fog-volume-shader-material.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume Shader Null",
    "file": "unit-fog-volume-shader-null.tscn",
    "category": "Other"
  },
  {
    "name": "Fog Volume",
    "file": "unit-fog-volume.tscn",
    "category": "Other"
  },
  {
    "name": "Fogvolume Gizmo",
    "file": "unit-fogvolume-gizmo.tscn",
    "category": "Other"
  },
  {
    "name": "Foldable Container Rtl",
    "file": "unit-foldable-container-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Foldable Container",
    "file": "unit-foldable-container.tscn",
    "category": "Other"
  },
  {
    "name": "Generic 6d Of Joint 3d",
    "file": "unit-generic-6d-of-joint-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Geometry Instance 3d",
    "file": "unit-geometry-instance-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Default Material",
    "file": "unit-glb-default-material.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Frames",
    "file": "unit-glb-frames.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Lightmap Miss",
    "file": "unit-glb-lightmap-miss.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Lightmap Uv2",
    "file": "unit-glb-lightmap-uv2.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Property Override",
    "file": "unit-glb-property-override.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Skeleton Override",
    "file": "unit-glb-skeleton-override.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Surface Material Override",
    "file": "unit-glb-surface-material-override.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Typed Child Visibility Parent",
    "file": "unit-glb-typed-child-visibility-parent.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Typed Child",
    "file": "unit-glb-typed-child.tscn",
    "category": "Other"
  },
  {
    "name": "Glb Viewport Texture",
    "file": "unit-glb-viewport-texture.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Agx",
    "file": "unit-glow-agx.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Authored",
    "file": "unit-glow-authored.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Auto Exposure",
    "file": "unit-glow-auto-exposure.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Bloom Floor",
    "file": "unit-glow-bloom-floor.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Exposure",
    "file": "unit-glow-exposure.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Map Viewport Texture Local",
    "file": "unit-glow-map-viewport-texture-local.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Map Viewport Texture Shared",
    "file": "unit-glow-map-viewport-texture-shared.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Map",
    "file": "unit-glow-map.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Mix",
    "file": "unit-glow-mix.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Normalized",
    "file": "unit-glow-normalized.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Replace",
    "file": "unit-glow-replace.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Softlight",
    "file": "unit-glow-softlight.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Specular",
    "file": "unit-glow-specular.tscn",
    "category": "Other"
  },
  {
    "name": "Glow Strength",
    "file": "unit-glow-strength.tscn",
    "category": "Other"
  },
  {
    "name": "Gltf Alpha Border",
    "file": "unit-gltf-alpha-border.tscn",
    "category": "Other"
  },
  {
    "name": "Gltf External",
    "file": "unit-gltf-external.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles 2d",
    "file": "unit-gpu-particles-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Attractor Box 3d",
    "file": "unit-gpu-particles-attractor-box-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Attractor Sphere 3d",
    "file": "unit-gpu-particles-attractor-sphere-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Attractor Vector Field 3d",
    "file": "unit-gpu-particles-attractor-vector-field-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Collision Box 3d",
    "file": "unit-gpu-particles-collision-box-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Collision Gizmos",
    "file": "unit-gpu-particles-collision-gizmos.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Collision Height Field 3d",
    "file": "unit-gpu-particles-collision-height-field-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Collision Sdf 3d",
    "file": "unit-gpu-particles-collision-sdf-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpu Particles Collision Sphere 3d",
    "file": "unit-gpu-particles-collision-sphere-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Gpuparticles3d Emission",
    "file": "unit-gpuparticles3d-emission.tscn",
    "category": "Other"
  },
  {
    "name": "Gpuparticles3d",
    "file": "unit-gpuparticles3d.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Arrange Button Hidden",
    "file": "unit-graph-edit-arrange-button-hidden.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Grid Buttons Hidden",
    "file": "unit-graph-edit-grid-buttons-hidden.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Menu Hidden",
    "file": "unit-graph-edit-menu-hidden.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Minimap Button Hidden",
    "file": "unit-graph-edit-minimap-button-hidden.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Minimap Connection Origin",
    "file": "unit-graph-edit-minimap-connection-origin.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Minimap Connection",
    "file": "unit-graph-edit-minimap-connection.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Minimap Disabled",
    "file": "unit-graph-edit-minimap-disabled.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Minimap Opacity",
    "file": "unit-graph-edit-minimap-opacity.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Minimap Size",
    "file": "unit-graph-edit-minimap-size.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Scroll Offset Clamped",
    "file": "unit-graph-edit-scroll-offset-clamped.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Zoom Bound Order",
    "file": "unit-graph-edit-zoom-bound-order.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Zoom Buttons Hidden",
    "file": "unit-graph-edit-zoom-buttons-hidden.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit Zoom Label",
    "file": "unit-graph-edit-zoom-label.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Edit",
    "file": "unit-graph-edit.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Element",
    "file": "unit-graph-element.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Frame",
    "file": "unit-graph-frame.tscn",
    "category": "Other"
  },
  {
    "name": "Graph Node",
    "file": "unit-graph-node.tscn",
    "category": "Other"
  },
  {
    "name": "Grid Map Billboard Shadow",
    "file": "unit-grid-map-billboard-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Grid Map Billboard",
    "file": "unit-grid-map-billboard.tscn",
    "category": "Other"
  },
  {
    "name": "Grid Map Cell Scale",
    "file": "unit-grid-map-cell-scale.tscn",
    "category": "Other"
  },
  {
    "name": "Grid Map Centering",
    "file": "unit-grid-map-centering.tscn",
    "category": "Other"
  },
  {
    "name": "Grid Map Inline Mesh",
    "file": "unit-grid-map-inline-mesh.tscn",
    "category": "Other"
  },
  {
    "name": "Grid Map",
    "file": "unit-grid-map.tscn",
    "category": "Other"
  },
  {
    "name": "Groove Joint 2d",
    "file": "unit-groove-joint-2d.tscn",
    "category": "Other"
  },
  {
    "name": "H Flow Container",
    "file": "unit-h-flow-container.tscn",
    "category": "Other"
  },
  {
    "name": "H Scroll Bar",
    "file": "unit-h-scroll-bar.tscn",
    "category": "Other"
  },
  {
    "name": "H Separator",
    "file": "unit-h-separator.tscn",
    "category": "Other"
  },
  {
    "name": "Hinge Joint 3d",
    "file": "unit-hinge-joint-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Hslider Rtl",
    "file": "unit-hslider-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Hslider",
    "file": "unit-hslider.tscn",
    "category": "Other"
  },
  {
    "name": "Http Request",
    "file": "unit-http-request.tscn",
    "category": "Other"
  },
  {
    "name": "Imagetexture Mipmaps",
    "file": "unit-imagetexture-mipmaps.tscn",
    "category": "Other"
  },
  {
    "name": "Importer Mesh Instance 3d",
    "file": "unit-importer-mesh-instance-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Instance Child",
    "file": "unit-instance-child.tscn",
    "category": "Other"
  },
  {
    "name": "Instanced Environment Child",
    "file": "unit-instanced-environment-child.tscn",
    "category": "Other"
  },
  {
    "name": "Instanced Environment",
    "file": "unit-instanced-environment.tscn",
    "category": "Other"
  },
  {
    "name": "Instanced Gizmo Grey Child",
    "file": "unit-instanced-gizmo-grey-child.tscn",
    "category": "Other"
  },
  {
    "name": "Instanced Gizmo Grey",
    "file": "unit-instanced-gizmo-grey.tscn",
    "category": "Other"
  },
  {
    "name": "Item List Guide Lines",
    "file": "unit-item-list-guide-lines.tscn",
    "category": "Other"
  },
  {
    "name": "Item List Legacy Items",
    "file": "unit-item-list-legacy-items.tscn",
    "category": "Other"
  },
  {
    "name": "Item List Rtl Icon Top",
    "file": "unit-item-list-rtl-icon-top.tscn",
    "category": "Other"
  },
  {
    "name": "Item List Rtl",
    "file": "unit-item-list-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Item List",
    "file": "unit-item-list.tscn",
    "category": "Other"
  },
  {
    "name": "Jacobian Ik 3d",
    "file": "unit-jacobian-ik-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Joint 3d Gizmos 6dof",
    "file": "unit-joint-3d-gizmos-6dof.tscn",
    "category": "Other"
  },
  {
    "name": "Joint 3d Gizmos Hinge Slider",
    "file": "unit-joint-3d-gizmos-hinge-slider.tscn",
    "category": "Other"
  },
  {
    "name": "Joint 3d Gizmos Pin Cone",
    "file": "unit-joint-3d-gizmos-pin-cone.tscn",
    "category": "Other"
  },
  {
    "name": "Label Autowrap In Container",
    "file": "unit-label-autowrap-in-container.tscn",
    "category": "Other"
  },
  {
    "name": "Label Font Variation Bundled Embolden",
    "file": "unit-label-font-variation-bundled-embolden.tscn",
    "category": "Other"
  },
  {
    "name": "Label Font Variation Embolden",
    "file": "unit-label-font-variation-embolden.tscn",
    "category": "Other"
  },
  {
    "name": "Label Label Settings Tres",
    "file": "unit-label-label-settings-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Label Label Settings",
    "file": "unit-label-label-settings.tscn",
    "category": "Other"
  },
  {
    "name": "Label Outline",
    "file": "unit-label-outline.tscn",
    "category": "Other"
  },
  {
    "name": "Label Rtl Alignment",
    "file": "unit-label-rtl-alignment.tscn",
    "category": "Other"
  },
  {
    "name": "Label Rtl Fill Autowrap",
    "file": "unit-label-rtl-fill-autowrap.tscn",
    "category": "Other"
  },
  {
    "name": "Label Rtl Visible Chars Auto",
    "file": "unit-label-rtl-visible-chars-auto.tscn",
    "category": "Other"
  },
  {
    "name": "Label Visible Characters",
    "file": "unit-label-visible-characters.tscn",
    "category": "Other"
  },
  {
    "name": "Label3d Legible",
    "file": "unit-label3d-legible.tscn",
    "category": "Other"
  },
  {
    "name": "Label3d Scene Font",
    "file": "unit-label3d-scene-font.tscn",
    "category": "Other"
  },
  {
    "name": "Label3d Shadow",
    "file": "unit-label3d-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Label3d",
    "file": "unit-label3d.tscn",
    "category": "Other"
  },
  {
    "name": "Layer Bitmask 32bit",
    "file": "unit-layer-bitmask-32bit.tscn",
    "category": "Other"
  },
  {
    "name": "Legacy Format",
    "file": "unit-legacy-format.tscn",
    "category": "Other"
  },
  {
    "name": "Light Base Properties",
    "file": "unit-light-base-properties.tscn",
    "category": "Other"
  },
  {
    "name": "Light Range Floor",
    "file": "unit-light-range-floor.tscn",
    "category": "Other"
  },
  {
    "name": "Light Specular",
    "file": "unit-light-specular.tscn",
    "category": "Other"
  },
  {
    "name": "Light Transport Ambient",
    "file": "unit-light-transport-ambient.tscn",
    "category": "Other"
  },
  {
    "name": "Light Transport Direct",
    "file": "unit-light-transport-direct.tscn",
    "category": "Other"
  },
  {
    "name": "Light Transport Sky Graded",
    "file": "unit-light-transport-sky-graded.tscn",
    "category": "Other"
  },
  {
    "name": "Light Transport Sky",
    "file": "unit-light-transport-sky.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi Baked",
    "file": "unit-lightmap-gi-baked.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi Directional",
    "file": "unit-lightmap-gi-directional.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi Exposure",
    "file": "unit-lightmap-gi-exposure.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi Gridmap",
    "file": "unit-lightmap-gi-gridmap.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi Shadowmask Only",
    "file": "unit-lightmap-gi-shadowmask-only.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi Shadowmask Overlay",
    "file": "unit-lightmap-gi-shadowmask-overlay.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi Shadowmask Replace",
    "file": "unit-lightmap-gi-shadowmask-replace.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Gi",
    "file": "unit-lightmap-gi.tscn",
    "category": "Other"
  },
  {
    "name": "Lightmap Probe",
    "file": "unit-lightmap-probe.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d Cull Mode Reversed",
    "file": "unit-lightoccluder2d-cull-mode-reversed.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d Cull Mode",
    "file": "unit-lightoccluder2d-cull-mode.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d Shadow Closed",
    "file": "unit-lightoccluder2d-shadow-closed.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d Shadow Color",
    "file": "unit-lightoccluder2d-shadow-color.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d Shadow Mask",
    "file": "unit-lightoccluder2d-shadow-mask.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d Shadow",
    "file": "unit-lightoccluder2d-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d Two Lights",
    "file": "unit-lightoccluder2d-two-lights.tscn",
    "category": "Other"
  },
  {
    "name": "Lightoccluder2d",
    "file": "unit-lightoccluder2d.tscn",
    "category": "Other"
  },
  {
    "name": "Limit Angular Velocity Modifier 3d",
    "file": "unit-limit-angular-velocity-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Line Edit Rtl",
    "file": "unit-line-edit-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Lineedit Clear Button",
    "file": "unit-lineedit-clear-button.tscn",
    "category": "Other"
  },
  {
    "name": "Lineedit Control Chars",
    "file": "unit-lineedit-control-chars.tscn",
    "category": "Other"
  },
  {
    "name": "Lineedit Max Length",
    "file": "unit-lineedit-max-length.tscn",
    "category": "Other"
  },
  {
    "name": "Lineedit Right Icon",
    "file": "unit-lineedit-right-icon.tscn",
    "category": "Other"
  },
  {
    "name": "Lineedit",
    "file": "unit-lineedit.tscn",
    "category": "Other"
  },
  {
    "name": "Link Button Rtl",
    "file": "unit-link-button-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Link Button",
    "file": "unit-link-button.tscn",
    "category": "Other"
  },
  {
    "name": "Look At Modifier 3d",
    "file": "unit-look-at-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Marker 3d",
    "file": "unit-marker-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Menu Bar Rtl",
    "file": "unit-menu-bar-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Menu Bar",
    "file": "unit-menu-bar.tscn",
    "category": "Other"
  },
  {
    "name": "Menu Button",
    "file": "unit-menu-button.tscn",
    "category": "Other"
  },
  {
    "name": "Modifier Bone Target 3d",
    "file": "unit-modifier-bone-target-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Modulate Cascade",
    "file": "unit-modulate-cascade.tscn",
    "category": "Other"
  },
  {
    "name": "Multi Camera",
    "file": "unit-multi-camera.tscn",
    "category": "Other"
  },
  {
    "name": "Multi Mesh Instance 2d",
    "file": "unit-multi-mesh-instance-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Multi Mesh Instance 3d",
    "file": "unit-multi-mesh-instance-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Multiplayer Spawner",
    "file": "unit-multiplayer-spawner.tscn",
    "category": "Other"
  },
  {
    "name": "Multiplayer Synchronizer",
    "file": "unit-multiplayer-synchronizer.tscn",
    "category": "Other"
  },
  {
    "name": "Nine Patch Rect",
    "file": "unit-nine-patch-rect.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d 4096 Seamless",
    "file": "unit-noisetexture2d-4096-seamless.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d 4096 Tres",
    "file": "unit-noisetexture2d-4096-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d Domain Warp",
    "file": "unit-noisetexture2d-domain-warp.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d Mipmaps",
    "file": "unit-noisetexture2d-mipmaps.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d Normal",
    "file": "unit-noisetexture2d-normal.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d Tiled",
    "file": "unit-noisetexture2d-tiled.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d Tres",
    "file": "unit-noisetexture2d-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Noisetexture2d",
    "file": "unit-noisetexture2d.tscn",
    "category": "Other"
  },
  {
    "name": "Occluder Instance 3d",
    "file": "unit-occluder-instance-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Omni Light 3d",
    "file": "unit-omni-light-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Omni Light Shadow Blur",
    "file": "unit-omni-light-shadow-blur.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Binding Modifier Editor",
    "file": "unit-open-xr-binding-modifier-editor.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Composition Layer Cylinder",
    "file": "unit-open-xr-composition-layer-cylinder.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Composition Layer Equirect",
    "file": "unit-open-xr-composition-layer-equirect.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Composition Layer Quad",
    "file": "unit-open-xr-composition-layer-quad.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Hand",
    "file": "unit-open-xr-hand.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Interaction Profile Editor",
    "file": "unit-open-xr-interaction-profile-editor.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Render Model Manager",
    "file": "unit-open-xr-render-model-manager.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Render Model",
    "file": "unit-open-xr-render-model.tscn",
    "category": "Other"
  },
  {
    "name": "Open Xr Visibility Mask",
    "file": "unit-open-xr-visibility-mask.tscn",
    "category": "Other"
  },
  {
    "name": "Orphan Reroot",
    "file": "unit-orphan-reroot.tscn",
    "category": "Other"
  },
  {
    "name": "Path3d",
    "file": "unit-path3d.tscn",
    "category": "Other"
  },
  {
    "name": "Pathfollow 3d",
    "file": "unit-pathfollow-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Photo Frame Base",
    "file": "unit-photo-frame-base.tscn",
    "category": "Other"
  },
  {
    "name": "Physical Bone 2d",
    "file": "unit-physical-bone-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Physical Bone 3d",
    "file": "unit-physical-bone-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Physical Bone Simulator 3d",
    "file": "unit-physical-bone-simulator-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Pin Joint 2d",
    "file": "unit-pin-joint-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Pin Joint 3d",
    "file": "unit-pin-joint-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Point Mesh Gridmap",
    "file": "unit-point-mesh-gridmap.tscn",
    "category": "Other"
  },
  {
    "name": "Point Mesh Omni Shadow",
    "file": "unit-point-mesh-omni-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Point Mesh",
    "file": "unit-point-mesh.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Blend",
    "file": "unit-pointlight2d-blend.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Cookie Edge",
    "file": "unit-pointlight2d-cookie-edge.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Cull Mask",
    "file": "unit-pointlight2d-cull-mask.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Gradient",
    "file": "unit-pointlight2d-gradient.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Item Light Cap",
    "file": "unit-pointlight2d-item-light-cap.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Lightonly",
    "file": "unit-pointlight2d-lightonly.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Many Masks",
    "file": "unit-pointlight2d-many-masks.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Mix Order",
    "file": "unit-pointlight2d-mix-order.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Mix Over Shadow Color",
    "file": "unit-pointlight2d-mix-over-shadow-color.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Mix Shadow Color",
    "file": "unit-pointlight2d-mix-shadow-color.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Normal Map Height",
    "file": "unit-pointlight2d-normal-map-height.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Normal Map Specular",
    "file": "unit-pointlight2d-normal-map-specular.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Range Layer",
    "file": "unit-pointlight2d-range-layer.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Range Z",
    "file": "unit-pointlight2d-range-z.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Shadow Item Mask",
    "file": "unit-pointlight2d-shadow-item-mask.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Shadow Pcf Color",
    "file": "unit-pointlight2d-shadow-pcf-color.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Shadow Pcf13",
    "file": "unit-pointlight2d-shadow-pcf13.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Shadow Pcf5",
    "file": "unit-pointlight2d-shadow-pcf5.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d Untextured",
    "file": "unit-pointlight2d-untextured.tscn",
    "category": "Other"
  },
  {
    "name": "Pointlight2d",
    "file": "unit-pointlight2d.tscn",
    "category": "Other"
  },
  {
    "name": "Popup Menu",
    "file": "unit-popup-menu.tscn",
    "category": "Other"
  },
  {
    "name": "Popup Panel",
    "file": "unit-popup-panel.tscn",
    "category": "Other"
  },
  {
    "name": "Popup",
    "file": "unit-popup.tscn",
    "category": "Other"
  },
  {
    "name": "Preview Lighting",
    "file": "unit-preview-lighting.tscn",
    "category": "Other"
  },
  {
    "name": "Primitive Mesh Flip Faces",
    "file": "unit-primitive-mesh-flip-faces.tscn",
    "category": "Other"
  },
  {
    "name": "Primitive Mesh Normal Map",
    "file": "unit-primitive-mesh-normal-map.tscn",
    "category": "Other"
  },
  {
    "name": "Primitive Mesh Uv2",
    "file": "unit-primitive-mesh-uv2.tscn",
    "category": "Other"
  },
  {
    "name": "Progress Bar Embolden Fill",
    "file": "unit-progress-bar-embolden-fill.tscn",
    "category": "Other"
  },
  {
    "name": "Progress Bar Outline Variation",
    "file": "unit-progress-bar-outline-variation.tscn",
    "category": "Other"
  },
  {
    "name": "Progress Bar Rtl",
    "file": "unit-progress-bar-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Progress Bar",
    "file": "unit-progress-bar.tscn",
    "category": "Other"
  },
  {
    "name": "Range",
    "file": "unit-range.tscn",
    "category": "Other"
  },
  {
    "name": "Ray Cast 2d",
    "file": "unit-ray-cast-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Ray Cast 3d",
    "file": "unit-ray-cast-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Reference Rect",
    "file": "unit-reference-rect.tscn",
    "category": "Other"
  },
  {
    "name": "Reflection Probe Always",
    "file": "unit-reflection-probe-always.tscn",
    "category": "Other"
  },
  {
    "name": "Reflection Probe Ambient Color",
    "file": "unit-reflection-probe-ambient-color.tscn",
    "category": "Other"
  },
  {
    "name": "Reflection Probe Box Projection",
    "file": "unit-reflection-probe-box-projection.tscn",
    "category": "Other"
  },
  {
    "name": "Reflection Probe Camera Environment",
    "file": "unit-reflection-probe-camera-environment.tscn",
    "category": "Other"
  },
  {
    "name": "Reflection Probe Camera Exposure",
    "file": "unit-reflection-probe-camera-exposure.tscn",
    "category": "Other"
  },
  {
    "name": "Reflection Probe",
    "file": "unit-reflection-probe.tscn",
    "category": "Other"
  },
  {
    "name": "Reflectionprobe Gizmo",
    "file": "unit-reflectionprobe-gizmo.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 2d Instanced",
    "file": "unit-remote-transform-2d-instanced.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 2d Local",
    "file": "unit-remote-transform-2d-local.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 2d Skew",
    "file": "unit-remote-transform-2d-skew.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 2d",
    "file": "unit-remote-transform-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 3d Ancestor",
    "file": "unit-remote-transform-3d-ancestor.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 3d Instanced",
    "file": "unit-remote-transform-3d-instanced.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 3d Local",
    "file": "unit-remote-transform-3d-local.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 3d Sheared Target",
    "file": "unit-remote-transform-3d-sheared-target.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform 3d",
    "file": "unit-remote-transform-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Remote Transform Unique Name",
    "file": "unit-remote-transform-unique-name.tscn",
    "category": "Other"
  },
  {
    "name": "Resource Preloader",
    "file": "unit-resource-preloader.tscn",
    "category": "Other"
  },
  {
    "name": "Retarget Modifier 3d",
    "file": "unit-retarget-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Ribbon Trail Mesh Texture Uv",
    "file": "unit-ribbon-trail-mesh-texture-uv.tscn",
    "category": "Other"
  },
  {
    "name": "Rigidbody2d",
    "file": "unit-rigidbody2d.tscn",
    "category": "Other"
  },
  {
    "name": "Rigidbody3d",
    "file": "unit-rigidbody3d.tscn",
    "category": "Other"
  },
  {
    "name": "Root Motion View",
    "file": "unit-root-motion-view.tscn",
    "category": "Other"
  },
  {
    "name": "Scene Buffer Half Float",
    "file": "unit-scene-buffer-half-float.tscn",
    "category": "Other"
  },
  {
    "name": "Script Create Dialog",
    "file": "unit-script-create-dialog.tscn",
    "category": "Other"
  },
  {
    "name": "Shader Globals Override",
    "file": "unit-shader-globals-override.tscn",
    "category": "Other"
  },
  {
    "name": "Shader Sky Env",
    "file": "unit-shader-sky-env.tscn",
    "category": "Other"
  },
  {
    "name": "Shadows Only",
    "file": "unit-shadows-only.tscn",
    "category": "Other"
  },
  {
    "name": "Shape Cast 2d",
    "file": "unit-shape-cast-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Shape Cast 3d",
    "file": "unit-shape-cast-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Skeleton 2d",
    "file": "unit-skeleton-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Skeleton Ik 3d",
    "file": "unit-skeleton-ik-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Skeleton Modifier 3d",
    "file": "unit-skeleton-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Ambient Energy",
    "file": "unit-sky-ambient-energy.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Debanding Off",
    "file": "unit-sky-debanding-off.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Energy",
    "file": "unit-sky-energy.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Orthographic",
    "file": "unit-sky-orthographic.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Panorama Nearest",
    "file": "unit-sky-panorama-nearest.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Panorama Tres",
    "file": "unit-sky-panorama-tres.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Panorama Viewport Texture Local",
    "file": "unit-sky-panorama-viewport-texture-local.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Panorama Viewport Texture Shared",
    "file": "unit-sky-panorama-viewport-texture-shared.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Panorama",
    "file": "unit-sky-panorama.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Physical",
    "file": "unit-sky-physical.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Procedural",
    "file": "unit-sky-procedural.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Radiance Size 32",
    "file": "unit-sky-radiance-size-32.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Realtime",
    "file": "unit-sky-realtime.tscn",
    "category": "Other"
  },
  {
    "name": "Sky Sun Angular Distance",
    "file": "unit-sky-sun-angular-distance.tscn",
    "category": "Other"
  },
  {
    "name": "Slider Joint 3d",
    "file": "unit-slider-joint-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Soft Body 3d",
    "file": "unit-soft-body-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Softbody3d",
    "file": "unit-softbody3d.tscn",
    "category": "Other"
  },
  {
    "name": "Spin Box Rtl",
    "file": "unit-spin-box-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Spin Box",
    "file": "unit-spin-box.tscn",
    "category": "Other"
  },
  {
    "name": "Spline Ik 3d",
    "file": "unit-spline-ik-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Split Container Offsets",
    "file": "unit-split-container-offsets.tscn",
    "category": "Other"
  },
  {
    "name": "Split Container Rtl",
    "file": "unit-split-container-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Split Container Vertical",
    "file": "unit-split-container-vertical.tscn",
    "category": "Other"
  },
  {
    "name": "Split Container",
    "file": "unit-split-container.tscn",
    "category": "Other"
  },
  {
    "name": "Spot Light 3d",
    "file": "unit-spot-light-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Spot Light Shadow Blur",
    "file": "unit-spot-light-shadow-blur.tscn",
    "category": "Other"
  },
  {
    "name": "Spring Arm 3d",
    "file": "unit-spring-arm-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Spring Bone Collision 3d",
    "file": "unit-spring-bone-collision-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Spring Bone Collision Capsule 3d",
    "file": "unit-spring-bone-collision-capsule-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Spring Bone Collision Plane 3d",
    "file": "unit-spring-bone-collision-plane-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Spring Bone Collision Sphere 3d",
    "file": "unit-spring-bone-collision-sphere-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Spring Bone Simulator 3d",
    "file": "unit-spring-bone-simulator-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite 2d Shared World Content",
    "file": "unit-sprite-2d-shared-world-content.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite 2d Shared World Environment",
    "file": "unit-sprite-2d-shared-world-environment.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite 2d Shared World First Environment",
    "file": "unit-sprite-2d-shared-world-first-environment.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite 2d Soft Alpha Border",
    "file": "unit-sprite-2d-soft-alpha-border.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite 2d Viewport Texture Frame",
    "file": "unit-sprite-2d-viewport-texture-frame.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite 2d Viewport Texture",
    "file": "unit-sprite-2d-viewport-texture.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Billboard Fixed Y",
    "file": "unit-sprite3d-billboard-fixed-y.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Blended Pass",
    "file": "unit-sprite3d-blended-pass.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Gradienttexture",
    "file": "unit-sprite3d-gradienttexture.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Nested Modulate",
    "file": "unit-sprite3d-nested-modulate.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Region Oversized",
    "file": "unit-sprite3d-region-oversized.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Shadow",
    "file": "unit-sprite3d-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Texture Filter Anisotropic",
    "file": "unit-sprite3d-texture-filter-anisotropic.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d Untextured",
    "file": "unit-sprite3d-untextured.tscn",
    "category": "Other"
  },
  {
    "name": "Sprite3d",
    "file": "unit-sprite3d.tscn",
    "category": "Other"
  },
  {
    "name": "Stage Ambient Ibl",
    "file": "unit-stage-ambient-ibl.tscn",
    "category": "Other"
  },
  {
    "name": "Staticbody2d",
    "file": "unit-staticbody2d.tscn",
    "category": "Other"
  },
  {
    "name": "Status Indicator",
    "file": "unit-status-indicator.tscn",
    "category": "Other"
  },
  {
    "name": "Subtree Under Leaf Nodes",
    "file": "unit-subtree-under-leaf-nodes.tscn",
    "category": "Other"
  },
  {
    "name": "Subviewport Control Edge On Pixel Centre",
    "file": "unit-subviewport-control-edge-on-pixel-centre.tscn",
    "category": "Other"
  },
  {
    "name": "Subviewport Edge On Pixel Centre",
    "file": "unit-subviewport-edge-on-pixel-centre.tscn",
    "category": "Other"
  },
  {
    "name": "Surface Material Override",
    "file": "unit-surface-material-override.tscn",
    "category": "Other"
  },
  {
    "name": "Tab Bar Rtl Scroll",
    "file": "unit-tab-bar-rtl-scroll.tscn",
    "category": "Other"
  },
  {
    "name": "Tab Bar Rtl",
    "file": "unit-tab-bar-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Tab Bar",
    "file": "unit-tab-bar.tscn",
    "category": "Other"
  },
  {
    "name": "Tab Container Current Page",
    "file": "unit-tab-container-current-page.tscn",
    "category": "Other"
  },
  {
    "name": "Tab Container Rtl",
    "file": "unit-tab-container-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Tab Container",
    "file": "unit-tab-container.tscn",
    "category": "Other"
  },
  {
    "name": "Tab Font Size Override",
    "file": "unit-tab-font-size-override.tscn",
    "category": "Other"
  },
  {
    "name": "Text Edit Caret Readonly",
    "file": "unit-text-edit-caret-readonly.tscn",
    "category": "Other"
  },
  {
    "name": "Text Edit Indent Wrapped",
    "file": "unit-text-edit-indent-wrapped.tscn",
    "category": "Other"
  },
  {
    "name": "Text Edit Rtl",
    "file": "unit-text-edit-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Text Edit",
    "file": "unit-text-edit.tscn",
    "category": "Other"
  },
  {
    "name": "Texture Button",
    "file": "unit-texture-button.tscn",
    "category": "Other"
  },
  {
    "name": "Texture Progress Bar Partial",
    "file": "unit-texture-progress-bar-partial.tscn",
    "category": "Other"
  },
  {
    "name": "Texture Progress Bar",
    "file": "unit-texture-progress-bar.tscn",
    "category": "Other"
  },
  {
    "name": "Texturerect Atlastexture",
    "file": "unit-texturerect-atlastexture.tscn",
    "category": "Other"
  },
  {
    "name": "Texturerect Gradienttexture",
    "file": "unit-texturerect-gradienttexture.tscn",
    "category": "Other"
  },
  {
    "name": "Timer",
    "file": "unit-timer.tscn",
    "category": "Other"
  },
  {
    "name": "Tonemap Agx Shadow",
    "file": "unit-tonemap-agx-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Trail Inherited Base",
    "file": "unit-trail-inherited-base.tscn",
    "category": "Other"
  },
  {
    "name": "Trail Player",
    "file": "unit-trail-player.tscn",
    "category": "Other"
  },
  {
    "name": "Transform Only 3d Hidden",
    "file": "unit-transform-only-3d-hidden.tscn",
    "category": "Other"
  },
  {
    "name": "Tree Rtl",
    "file": "unit-tree-rtl.tscn",
    "category": "Other"
  },
  {
    "name": "Tree",
    "file": "unit-tree.tscn",
    "category": "Other"
  },
  {
    "name": "Tube Trail Mesh Texture Uv",
    "file": "unit-tube-trail-mesh-texture-uv.tscn",
    "category": "Other"
  },
  {
    "name": "Two Bone Ik 3d",
    "file": "unit-two-bone-ik-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Unique Name Pivot",
    "file": "unit-unique-name-pivot.tscn",
    "category": "Other"
  },
  {
    "name": "Unique Viewport Base",
    "file": "unit-unique-viewport-base.tscn",
    "category": "Other"
  },
  {
    "name": "Unique Viewport Inherited",
    "file": "unit-unique-viewport-inherited.tscn",
    "category": "Other"
  },
  {
    "name": "Unsupported Nodes",
    "file": "unit-unsupported-nodes.tscn",
    "category": "Other"
  },
  {
    "name": "Uv Scale",
    "file": "unit-uv-scale.tscn",
    "category": "Other"
  },
  {
    "name": "V Flow Container",
    "file": "unit-v-flow-container.tscn",
    "category": "Other"
  },
  {
    "name": "V Scroll Bar",
    "file": "unit-v-scroll-bar.tscn",
    "category": "Other"
  },
  {
    "name": "V Separator",
    "file": "unit-v-separator.tscn",
    "category": "Other"
  },
  {
    "name": "Video Stream Player",
    "file": "unit-video-stream-player.tscn",
    "category": "Other"
  },
  {
    "name": "Viewport Texture Local To Scene",
    "file": "unit-viewport-texture-local-to-scene.tscn",
    "category": "Other"
  },
  {
    "name": "Visibility Parent",
    "file": "unit-visibility-parent.tscn",
    "category": "Other"
  },
  {
    "name": "Visibility Range",
    "file": "unit-visibility-range.tscn",
    "category": "Other"
  },
  {
    "name": "Visible On Screen Enabler 2d",
    "file": "unit-visible-on-screen-enabler-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Visible On Screen Enabler 3d",
    "file": "unit-visible-on-screen-enabler-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Visible On Screen Notifier 2d",
    "file": "unit-visible-on-screen-notifier-2d.tscn",
    "category": "Other"
  },
  {
    "name": "Visible On Screen Notifier 3d",
    "file": "unit-visible-on-screen-notifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Visibleonscreenenabler3d Gizmo",
    "file": "unit-visibleonscreenenabler3d-gizmo.tscn",
    "category": "Other"
  },
  {
    "name": "Visibleonscreennotifier3d Gizmo",
    "file": "unit-visibleonscreennotifier3d-gizmo.tscn",
    "category": "Other"
  },
  {
    "name": "Visual Instance 3d",
    "file": "unit-visual-instance-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Volumetric Fog Color Background",
    "file": "unit-volumetric-fog-color-background.tscn",
    "category": "Other"
  },
  {
    "name": "Volumetric Fog Shadow",
    "file": "unit-volumetric-fog-shadow.tscn",
    "category": "Other"
  },
  {
    "name": "Volumetric Fog Sky Ambient",
    "file": "unit-volumetric-fog-sky-ambient.tscn",
    "category": "Other"
  },
  {
    "name": "Volumetric Fog Spot Origin",
    "file": "unit-volumetric-fog-spot-origin.tscn",
    "category": "Other"
  },
  {
    "name": "Volumetric Fog Spot Shadow Bias",
    "file": "unit-volumetric-fog-spot-shadow-bias.tscn",
    "category": "Other"
  },
  {
    "name": "Voxel Gi",
    "file": "unit-voxel-gi.tscn",
    "category": "Other"
  },
  {
    "name": "Voxelgi Gizmo",
    "file": "unit-voxelgi-gizmo.tscn",
    "category": "Other"
  },
  {
    "name": "Vslider",
    "file": "unit-vslider.tscn",
    "category": "Other"
  },
  {
    "name": "Window",
    "file": "unit-window.tscn",
    "category": "Other"
  },
  {
    "name": "World Environment Basic",
    "file": "unit-world-environment-basic.tscn",
    "category": "Other"
  },
  {
    "name": "World Environment Missing",
    "file": "unit-world-environment-missing.tscn",
    "category": "Other"
  },
  {
    "name": "World Environment No Fog",
    "file": "unit-world-environment-no-fog.tscn",
    "category": "Other"
  },
  {
    "name": "World Environment None",
    "file": "unit-world-environment-none.tscn",
    "category": "Other"
  },
  {
    "name": "World Environment Tree Order Child",
    "file": "unit-world-environment-tree-order-child.tscn",
    "category": "Other"
  },
  {
    "name": "World Environment Tree Order",
    "file": "unit-world-environment-tree-order.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Anchor 3d",
    "file": "unit-xr-anchor-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Body Modifier 3d",
    "file": "unit-xr-body-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Camera 3d",
    "file": "unit-xr-camera-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Controller 3d",
    "file": "unit-xr-controller-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Face Modifier 3d",
    "file": "unit-xr-face-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Hand Modifier 3d",
    "file": "unit-xr-hand-modifier-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Node 3d",
    "file": "unit-xr-node-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Xr Origin 3d",
    "file": "unit-xr-origin-3d.tscn",
    "category": "Other"
  },
  {
    "name": "Ysort Own Body",
    "file": "unit-ysort-own-body.tscn",
    "category": "Other"
  },
  {
    "name": "Alpha Antialiasing",
    "file": "alpha-antialiasing/unit-alpha-antialiasing.tscn",
    "category": "Other",
    "root": "alpha-antialiasing"
  },
  {
    "name": "Debanding",
    "file": "debanding/unit-debanding.tscn",
    "category": "Other",
    "root": "debanding"
  },
  {
    "name": "Decal Filter",
    "file": "decal-filter/unit-decal-filter.tscn",
    "category": "Other",
    "root": "decal-filter"
  },
  {
    "name": "Glow Linear Upscale",
    "file": "glow-linear-upscale/unit-glow-linear-upscale.tscn",
    "category": "Other",
    "root": "glow-linear-upscale"
  },
  {
    "name": "Label3d Glyph Mipmaps",
    "file": "label3d-glyph-mipmaps/unit-label3d-glyph-mipmaps.tscn",
    "category": "Other",
    "root": "label3d-glyph-mipmaps"
  },
  {
    "name": "Msaa 2d",
    "file": "msaa-2d/unit-msaa-2d.tscn",
    "category": "Other",
    "root": "msaa-2d"
  },
  {
    "name": "Msaa 3d",
    "file": "msaa-3d/unit-msaa-3d.tscn",
    "category": "Other",
    "root": "msaa-3d"
  },
  {
    "name": "Label Project Default Font",
    "file": "project-default-font/unit-label-project-default-font.tscn",
    "category": "Other",
    "root": "project-default-font"
  },
  {
    "name": "Label Variation Default Base",
    "file": "project-default-font/unit-label-variation-default-base.tscn",
    "category": "Other",
    "root": "project-default-font"
  },
  {
    "name": "Subviewport Snap Off",
    "file": "subviewport-snap-off/unit-subviewport-snap-off.tscn",
    "category": "Other",
    "root": "subviewport-snap-off"
  },
  {
    "name": "Touch Screen Button",
    "file": "touch-screen-button/unit-touch-screen-button.tscn",
    "category": "Other",
    "root": "touch-screen-button"
  },
  {
    "name": "Animation Empty Library",
    "file": "edge-animation-empty-library.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Animation Library Missing Subresource",
    "file": "edge-animation-library-missing-subresource.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Animation Track Missing Target",
    "file": "edge-animation-track-missing-target.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Area2d Gravity Point Incomplete",
    "file": "edge-area2d-gravity-point-incomplete.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Area2d Inactive",
    "file": "edge-area2d-inactive.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Area2d No Collision Shape",
    "file": "edge-area2d-no-collision-shape.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Area3d Bad Gravity Point",
    "file": "edge-area3d-bad-gravity-point.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Area3d Inactive",
    "file": "edge-area3d-inactive.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Collision Shape Disabled",
    "file": "edge-collision-shape-disabled.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Connection Missing Field",
    "file": "edge-connection-missing-field.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Csg Invalid Operation",
    "file": "edge-csg-invalid-operation.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Csg Invalid Size",
    "file": "edge-csg-invalid-size.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Csg Out Of Range",
    "file": "edge-csg-out-of-range.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Editable Missing Path",
    "file": "edge-editable-missing-path.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Int Wrap Position",
    "file": "edge-int-wrap-position.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Invalid Cast Shadow",
    "file": "edge-invalid-cast-shadow.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Invalid Transform",
    "file": "edge-invalid-transform.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Label3d Malformed Text",
    "file": "edge-label3d-malformed-text.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Light Bad Shadow Splits",
    "file": "edge-light-bad-shadow-splits.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Light Invalid Color",
    "file": "edge-light-invalid-color.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Malformed Bracket",
    "file": "edge-malformed-bracket.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Meshinstance3d Missing Subresource",
    "file": "edge-meshinstance3d-missing-subresource.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Missing Parent",
    "file": "edge-missing-parent.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Mixed Resource Missing",
    "file": "edge-mixed-resource-missing.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Navigation Region 2d Missing Polygon",
    "file": "edge-navigation-region-2d-missing-polygon.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Navigation Region 3d Missing Mesh",
    "file": "edge-navigation-region-3d-missing-mesh.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Negative Scale",
    "file": "edge-negative-scale.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Omni Light No Range",
    "file": "edge-omni-light-no-range.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Photo Wall",
    "file": "edge-photo-wall.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Physics Missing Collision",
    "file": "edge-physics-missing-collision.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Plane Rotated Scaled",
    "file": "edge-plane-rotated-scaled.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Spot Light No Range",
    "file": "edge-spot-light-no-range.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Unsupported 2d Audio",
    "file": "edge-unsupported-2d-audio.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "World Environment Unsupported",
    "file": "edge-world-environment-unsupported.tscn",
    "category": "Edge Cases"
  },
  {
    "name": "Gltf Unsupported Required Extension",
    "file": "gltf-unsupported-required-extension/edge-gltf-unsupported-required-extension.tscn",
    "category": "Edge Cases",
    "root": "gltf-unsupported-required-extension"
  },
  {
    "name": "Dodge Player",
    "file": "example-dodge-player.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Hallway Mockup",
    "file": "example-hallway-mockup.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Hierarchy Deep",
    "file": "example-hierarchy-deep.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Hierarchy Wide",
    "file": "example-hierarchy-wide.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Missing Resources",
    "file": "example-missing-resources.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Perpendicular Walls",
    "file": "example-perpendicular-walls.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Plane Center Offset",
    "file": "example-plane-center-offset.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Pong",
    "file": "example-pong.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Ui Dialog",
    "file": "example-ui-dialog.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "Uv Scale Showcase",
    "file": "example-uv-scale-showcase.tscn",
    "category": "Examples - Complex Scenes"
  },
  {
    "name": "All Meshes",
    "file": "integration-all-meshes.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "All Primitives",
    "file": "integration-all-primitives.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Escaped Heading Lamp",
    "file": "integration-escaped-heading-lamp.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Escaped Heading Reroot",
    "file": "integration-escaped-heading-reroot.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Instanced Inherited Unique Viewport",
    "file": "integration-instanced-inherited-unique-viewport.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Instanced Subscene",
    "file": "integration-instanced-subscene.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Instanced Unique Parent Released",
    "file": "integration-instanced-unique-parent-released.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Instanced Unique Parent",
    "file": "integration-instanced-unique-parent.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Lights All Types",
    "file": "integration-lights-all-types.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Material Features",
    "file": "integration-material-features.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Material Reuse",
    "file": "integration-material-reuse.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Mixed Nodes",
    "file": "integration-mixed-nodes.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Multiple Externals",
    "file": "integration-multiple-externals.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Parent Child Scene",
    "file": "integration-parent-child-scene.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Plane Orientations",
    "file": "integration-plane-orientations.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Three Cubes",
    "file": "integration-three-cubes.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Foreign Owner In Content",
    "file": "integration-trail-foreign-owner-in-content.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Inherited Root Claim",
    "file": "integration-trail-inherited-root-claim.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Name In Content",
    "file": "integration-trail-name-in-content.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Owner Fallback",
    "file": "integration-trail-owner-fallback.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Owner In Content",
    "file": "integration-trail-owner-in-content.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Owner Other Instance",
    "file": "integration-trail-owner-other-instance.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Owner Root Fallback",
    "file": "integration-trail-owner-root-fallback.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Trail Parent In Content",
    "file": "integration-trail-parent-in-content.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "Unsupported Hierarchy",
    "file": "integration-unsupported-hierarchy.tscn",
    "category": "Integration - Multi-Node"
  },
  {
    "name": "External Only",
    "file": "integration-external-only.tscn",
    "category": "Integration - External Scenes"
  },
  {
    "name": "External Separation",
    "file": "integration-external-separation.tscn",
    "category": "Integration - External Scenes"
  },
  {
    "name": "2d Geometry Parity",
    "file": "unit-2d-geometry-parity.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Line2d",
    "file": "unit-line2d.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Marker2d",
    "file": "unit-marker2d.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Parallax 2d",
    "file": "unit-parallax-2d.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Parallax Background",
    "file": "unit-parallax-background.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Parallax Ignore Camera Zoom",
    "file": "unit-parallax-ignore-camera-zoom.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Parallax Layer",
    "file": "unit-parallax-layer.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Path2d",
    "file": "unit-path2d.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Pathfollow2d",
    "file": "unit-pathfollow2d.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Polygon2d Texture Repeat",
    "file": "unit-polygon2d-texture-repeat.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Polygon2d",
    "file": "unit-polygon2d.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Block Compressed",
    "file": "unit-sprite2d-block-compressed.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Canvastexture",
    "file": "unit-sprite2d-canvastexture.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Gradienttexture Tres",
    "file": "unit-sprite2d-gradienttexture-tres.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Gradienttexture",
    "file": "unit-sprite2d-gradienttexture.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Imagetexture Half Tres",
    "file": "unit-sprite2d-imagetexture-half-tres.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Imagetexture Tres",
    "file": "unit-sprite2d-imagetexture-tres.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Magnified",
    "file": "unit-sprite2d-magnified.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Noisetexture Tres",
    "file": "unit-sprite2d-noisetexture-tres.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Region Oversized",
    "file": "unit-sprite2d-region-oversized.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Texture Filter Inherited",
    "file": "unit-sprite2d-texture-filter-inherited.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Texture Filter Nearest Anisotropic",
    "file": "unit-sprite2d-texture-filter-nearest-anisotropic.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d Untextured",
    "file": "unit-sprite2d-untextured.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Sprite2d",
    "file": "unit-sprite2d.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Atlas Viewport Padding",
    "file": "unit-tile-atlas-viewport-padding.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Atlas Viewport Texture File",
    "file": "unit-tile-atlas-viewport-texture-file.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Flips",
    "file": "unit-tile-map-layer-flips.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Hexagon",
    "file": "unit-tile-map-layer-hexagon.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Isometric",
    "file": "unit-tile-map-layer-isometric.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Mixed Sources",
    "file": "unit-tile-map-layer-mixed-sources.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Texture Padding",
    "file": "unit-tile-map-layer-texture-padding.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Tile Material",
    "file": "unit-tile-map-layer-tile-material.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Tile Modulate",
    "file": "unit-tile-map-layer-tile-modulate.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Tile Y Sort Origin",
    "file": "unit-tile-map-layer-tile-y-sort-origin.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Tile Z Index",
    "file": "unit-tile-map-layer-tile-z-index.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer Untextured Source",
    "file": "unit-tile-map-layer-untextured-source.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map Layer",
    "file": "unit-tile-map-layer.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Tile Map",
    "file": "unit-tile-map.tscn",
    "category": "Unit - 2D Canvas"
  },
  {
    "name": "Area Light Atlas Texture",
    "file": "unit-area-light-atlas-texture.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Area Light Distance Fade",
    "file": "unit-area-light-distance-fade.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Area Light Fog Shadow",
    "file": "unit-area-light-fog-shadow.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Area Light Fog",
    "file": "unit-area-light-fog.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Area Light Modes",
    "file": "unit-area-light-modes.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Area Light Normalize",
    "file": "unit-area-light-normalize.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Area Light Texture",
    "file": "unit-area-light-texture.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Area Light3d",
    "file": "unit-area-light3d.tscn",
    "category": "Unit - Lights"
  },
  {
    "name": "Arraymesh Compressed",
    "file": "unit-arraymesh-compressed.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh Material Override",
    "file": "unit-arraymesh-material-override.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh Own Material",
    "file": "unit-arraymesh-own-material.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh Scene Material Override",
    "file": "unit-arraymesh-scene-material-override.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh Surface Override",
    "file": "unit-arraymesh-surface-override.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh Tangents",
    "file": "unit-arraymesh-tangents.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh Triangle Strip",
    "file": "unit-arraymesh-triangle-strip.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh Uv",
    "file": "unit-arraymesh-uv.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Arraymesh",
    "file": "unit-arraymesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Box Container",
    "file": "unit-box-container.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Box Mesh Texture Uv",
    "file": "unit-box-mesh-texture-uv.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Box Mesh",
    "file": "unit-box-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Capsule Mesh Texture Uv",
    "file": "unit-capsule-mesh-texture-uv.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Capsule Mesh",
    "file": "unit-capsule-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Cylinder Mesh Texture Uv",
    "file": "unit-cylinder-mesh-texture-uv.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Cylinder Mesh",
    "file": "unit-cylinder-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Mesh Instance 2d",
    "file": "unit-mesh-instance-2d.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Mesh Instance 3d Skin By Name",
    "file": "unit-mesh-instance-3d-skin-by-name.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Mesh Instance 3d Skinned Ribbon Instanced",
    "file": "unit-mesh-instance-3d-skinned-ribbon-instanced.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Mesh Instance 3d Skinned Ribbon",
    "file": "unit-mesh-instance-3d-skinned-ribbon.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Mesh Instance 3d Skinned Tube",
    "file": "unit-mesh-instance-3d-skinned-tube.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Mesh Instance Basic",
    "file": "unit-mesh-instance-basic.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Mesh Instance Scinotation Color",
    "file": "unit-mesh-instance-scinotation-color.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Meshinstance3d Material Overlay",
    "file": "unit-meshinstance3d-material-overlay.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Plane Mesh",
    "file": "unit-plane-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Planemesh Center Offset",
    "file": "unit-planemesh-center-offset.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Planemesh Flip Faces",
    "file": "unit-planemesh-flip-faces.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Prism Mesh Texture Uv",
    "file": "unit-prism-mesh-texture-uv.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Prism Mesh",
    "file": "unit-prism-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Quadmesh Orientation",
    "file": "unit-quadmesh-orientation.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Quadmesh",
    "file": "unit-quadmesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Sphere Mesh Texture Uv",
    "file": "unit-sphere-mesh-texture-uv.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Sphere Mesh",
    "file": "unit-sphere-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh Cff",
    "file": "unit-text-mesh-cff.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh Default Font",
    "file": "unit-text-mesh-default-font.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh Embolden",
    "file": "unit-text-mesh-embolden.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh Hinting",
    "file": "unit-text-mesh-hinting.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh Triangulation Failure",
    "file": "unit-text-mesh-triangulation-failure.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh Woff2",
    "file": "unit-text-mesh-woff2.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh",
    "file": "unit-text-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Torus Mesh Texture Uv",
    "file": "unit-torus-mesh-texture-uv.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Torus Mesh",
    "file": "unit-torus-mesh.tscn",
    "category": "Unit - Primitive Meshes"
  },
  {
    "name": "Text Mesh Project Default Font",
    "file": "project-default-font/unit-text-mesh-project-default-font.tscn",
    "category": "Unit - Primitive Meshes",
    "root": "project-default-font"
  },
  {
    "name": "Audio Listener 2d",
    "file": "unit-audio-listener-2d.tscn",
    "category": "Unit - Audio"
  },
  {
    "name": "Audio Listener 3d",
    "file": "unit-audio-listener-3d.tscn",
    "category": "Unit - Audio"
  },
  {
    "name": "Audio Stream Player 2d",
    "file": "unit-audio-stream-player-2d.tscn",
    "category": "Unit - Audio"
  },
  {
    "name": "Audio Stream Player",
    "file": "unit-audio-stream-player.tscn",
    "category": "Unit - Audio"
  },
  {
    "name": "Button Autowrap",
    "file": "unit-button-autowrap.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Button Icon Gradienttexture",
    "file": "unit-button-icon-gradienttexture.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Button Rtl",
    "file": "unit-button-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Button States",
    "file": "unit-button-states.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Button",
    "file": "unit-button.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Canvas Layer Light Order By Tree",
    "file": "unit-canvas-layer-light-order-by-tree.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Canvas Layer Light Order",
    "file": "unit-canvas-layer-light-order.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Canvas Layer Modulate Scope",
    "file": "unit-canvas-layer-modulate-scope.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Canvas Layer Transform",
    "file": "unit-canvas-layer-transform.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Canvas Layer",
    "file": "unit-canvas-layer.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Center Container",
    "file": "unit-center-container.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Checkbox Icon Magnified",
    "file": "unit-checkbox-icon-magnified.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Checkbox Icon Texture Filter Inherited",
    "file": "unit-checkbox-icon-texture-filter-inherited.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Checkbox Rtl",
    "file": "unit-checkbox-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Checkbox",
    "file": "unit-checkbox.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Color Rect",
    "file": "unit-color-rect.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Anchor Parent Node2d",
    "file": "unit-control-anchor-parent-node2d.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Anchor Parent Plain Node",
    "file": "unit-control-anchor-parent-plain-node.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Anchors Preset Gate",
    "file": "unit-control-anchors-preset-gate.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Anchors Preset Offsets",
    "file": "unit-control-anchors-preset-offsets.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Anchors Theme",
    "file": "unit-control-anchors-theme.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Canvas Item Material",
    "file": "unit-control-canvas-item-material.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Canvas Modulate",
    "file": "unit-control-canvas-modulate.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Containers",
    "file": "unit-control-containers.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Detached Paint Order",
    "file": "unit-control-detached-paint-order.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control In Parallax Background",
    "file": "unit-control-in-parallax-background.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Instanced Hud Badge",
    "file": "unit-control-instanced-hud-badge.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Instanced Hud Layer",
    "file": "unit-control-instanced-hud-layer.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Instanced Hud",
    "file": "unit-control-instanced-hud.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Layout Direction Inherit",
    "file": "unit-control-layout-direction-inherit.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Layout Direction Rtl",
    "file": "unit-control-layout-direction-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Light Mask",
    "file": "unit-control-light-mask.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Light2d",
    "file": "unit-control-light2d.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Nested Children",
    "file": "unit-control-nested-children.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Node2d Ancestor Hidden",
    "file": "unit-control-node2d-ancestor-hidden.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Node2d Ancestor Modulate",
    "file": "unit-control-node2d-ancestor-modulate.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Node2d Ancestor Transform",
    "file": "unit-control-node2d-ancestor-transform.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Promoted Ancestor Z",
    "file": "unit-control-promoted-ancestor-z.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Scene Font Magnified",
    "file": "unit-control-scene-font-magnified.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Scene Font Theme",
    "file": "unit-control-scene-font-theme.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Scene Font Typo Metrics",
    "file": "unit-control-scene-font-typo-metrics.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Scene Font Woff2",
    "file": "unit-control-scene-font-woff2.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control State",
    "file": "unit-control-state.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Theme Base Class",
    "file": "unit-control-theme-base-class.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Theme Stylebox Color",
    "file": "unit-control-theme-stylebox-color.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Themed Icon",
    "file": "unit-control-themed-icon.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Top Level Hidden Ancestor",
    "file": "unit-control-top-level-hidden-ancestor.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Top Level",
    "file": "unit-control-top-level.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Transform Modulate",
    "file": "unit-control-transform-modulate.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Grid Container Rtl",
    "file": "unit-grid-container-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Grid Container",
    "file": "unit-grid-container.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Hbox Container Stretch",
    "file": "unit-hbox-container-stretch.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Hbox Container",
    "file": "unit-hbox-container.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Label 2d Fill",
    "file": "unit-label-2d-fill.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Label 2d Trim",
    "file": "unit-label-2d-trim.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Label 2d Valign",
    "file": "unit-label-2d-valign.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Label 2d Wrap",
    "file": "unit-label-2d-wrap.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Label 2d",
    "file": "unit-label-2d.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Margin Container Rtl",
    "file": "unit-margin-container-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Margin Container",
    "file": "unit-margin-container.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Optionbutton Rtl",
    "file": "unit-optionbutton-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Optionbutton",
    "file": "unit-optionbutton.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Panel Container",
    "file": "unit-panel-container.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Panel Stylebox Skew Shadow",
    "file": "unit-panel-stylebox-skew-shadow.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Panel Styleboxes",
    "file": "unit-panel-styleboxes.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Panel",
    "file": "unit-panel.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Rich Text Label Center Overflow",
    "file": "unit-rich-text-label-center-overflow.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Rich Text Label Fractional Box",
    "file": "unit-rich-text-label-fractional-box.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Rich Text Label Rtl",
    "file": "unit-rich-text-label-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Rich Text Label Style Fonts",
    "file": "unit-rich-text-label-style-fonts.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Rich Text Label",
    "file": "unit-rich-text-label.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Scroll Container Bar Snap",
    "file": "unit-scroll-container-bar-snap.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Scroll Container Clip Quantize",
    "file": "unit-scroll-container-clip-quantize.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Scroll Container Clip",
    "file": "unit-scroll-container-clip.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Scroll Container Focus Border",
    "file": "unit-scroll-container-focus-border.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Scroll Container Rtl",
    "file": "unit-scroll-container-rtl.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Scroll Container Scroll Hint",
    "file": "unit-scroll-container-scroll-hint.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Scroll Container",
    "file": "unit-scroll-container.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Texture Rect Filter Inherit",
    "file": "unit-texture-rect-filter-inherit.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Texture Rect Viewport Texture Flip",
    "file": "unit-texture-rect-viewport-texture-flip.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Texture Rect Viewport Texture Wrapped",
    "file": "unit-texture-rect-viewport-texture-wrapped.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Texture Rect Viewport Texture",
    "file": "unit-texture-rect-viewport-texture.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Texture Rect",
    "file": "unit-texture-rect.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Vbox Container Pitch",
    "file": "unit-vbox-container-pitch.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Vbox Container",
    "file": "unit-vbox-container.tscn",
    "category": "Unit - 2D UI Controls"
  },
  {
    "name": "Control Layout Direction Force",
    "file": "layout-direction-force-rtl/unit-control-layout-direction-force.tscn",
    "category": "Unit - 2D UI Controls",
    "root": "layout-direction-force-rtl"
  },
  {
    "name": "Control Layout Direction Locale",
    "file": "layout-direction-locale-rtl/unit-control-layout-direction-locale.tscn",
    "category": "Unit - 2D UI Controls",
    "root": "layout-direction-locale-rtl"
  },
  {
    "name": "Control Layout Direction Root",
    "file": "layout-direction-root-rtl/unit-control-layout-direction-root.tscn",
    "category": "Unit - 2D UI Controls",
    "root": "layout-direction-root-rtl"
  },
  {
    "name": "Camera Attributes Auto Exposure Physical",
    "file": "unit-camera-attributes-auto-exposure-physical.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Camera Attributes Auto Exposure",
    "file": "unit-camera-attributes-auto-exposure.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Camera Attributes Exposure Camera",
    "file": "unit-camera-attributes-exposure-camera.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Camera Attributes Exposure Sky",
    "file": "unit-camera-attributes-exposure-sky.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Camera Attributes Exposure",
    "file": "unit-camera-attributes-exposure.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Camera Basic",
    "file": "unit-camera-basic.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Camera Frustum",
    "file": "unit-camera-frustum.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Camera3d",
    "file": "unit-camera3d.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Empty Scene",
    "file": "unit-empty-scene.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node Icons",
    "file": "unit-node-icons.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node Parent Id Path",
    "file": "unit-node-parent-id-path.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node2d Detached Transform",
    "file": "unit-node2d-detached-transform.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node2d Top Level",
    "file": "unit-node2d-top-level.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node3d Basic",
    "file": "unit-node3d-basic.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node3d Plain Node Transform",
    "file": "unit-node3d-plain-node-transform.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node3d Plain Node Visibility",
    "file": "unit-node3d-plain-node-visibility.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node3d Sheared Basis",
    "file": "unit-node3d-sheared-basis.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Node3d Top Level",
    "file": "unit-node3d-top-level.tscn",
    "category": "Unit - Basic Nodes"
  },
  {
    "name": "Collision Polygon 2d",
    "file": "unit-collision-polygon-2d.tscn",
    "category": "Unit - Physics"
  },
  {
    "name": "Collision Polygon 3d",
    "file": "unit-collision-polygon-3d.tscn",
    "category": "Unit - Physics"
  },
  {
    "name": "Collision Shapes",
    "file": "unit-collision-shapes.tscn",
    "category": "Unit - Physics"
  },
  {
    "name": "Collision World Boundary",
    "file": "unit-collision-world-boundary.tscn",
    "category": "Unit - Physics"
  },
  {
    "name": "Collisionshape2d",
    "file": "unit-collisionshape2d.tscn",
    "category": "Unit - Physics"
  },
  {
    "name": "Physics Bodies",
    "file": "unit-physics-bodies.tscn",
    "category": "Unit - Physics"
  },
  {
    "name": "Physics Vehicle",
    "file": "unit-physics-vehicle.tscn",
    "category": "Unit - Physics"
  },
  {
    "name": "Csg Alternating Ops",
    "file": "unit-csg-alternating-ops.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Boolean Ops",
    "file": "unit-csg-boolean-ops.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Box",
    "file": "unit-csg-box.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Combiner",
    "file": "unit-csg-combiner.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Cylinder",
    "file": "unit-csg-cylinder.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Defaults",
    "file": "unit-csg-defaults.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg External Material",
    "file": "unit-csg-external-material.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Invisible Contributor",
    "file": "unit-csg-invisible-contributor.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Mesh Open Brush",
    "file": "unit-csg-mesh-open-brush.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Mesh Sources",
    "file": "unit-csg-mesh-sources.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Mesh Text Mesh",
    "file": "unit-csg-mesh-text-mesh.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Mesh",
    "file": "unit-csg-mesh.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Multi Material",
    "file": "unit-csg-multi-material.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Nested Combiner Op",
    "file": "unit-csg-nested-combiner-op.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Polygon Depth",
    "file": "unit-csg-polygon-depth.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Polygon Path Instanced",
    "file": "unit-csg-polygon-path-instanced.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Polygon Path",
    "file": "unit-csg-polygon-path.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Polygon Spin",
    "file": "unit-csg-polygon-spin.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Sphere",
    "file": "unit-csg-sphere.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Texture Uv",
    "file": "unit-csg-texture-uv.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Torus",
    "file": "unit-csg-torus.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "Csg Transparency",
    "file": "unit-csg-transparency.tscn",
    "category": "Unit - CSG Primitives"
  },
  {
    "name": "External Cube",
    "file": "unit-external-cube.tscn",
    "category": "Unit - External Resources"
  },
  {
    "name": "External Material Roughness",
    "file": "unit-external-material-roughness.tscn",
    "category": "Unit - External Resources"
  },
  {
    "name": "External Material",
    "file": "unit-external-material.tscn",
    "category": "Unit - External Resources"
  },
  {
    "name": "External Missing",
    "file": "unit-external-missing.tscn",
    "category": "Unit - External Resources"
  },
  {
    "name": "External Sphere",
    "file": "unit-external-sphere.tscn",
    "category": "Unit - External Resources"
  },
  {
    "name": "External Texture",
    "file": "unit-external-texture.tscn",
    "category": "Unit - External Resources"
  },
  {
    "name": "Material Albedo Atlas Texture",
    "file": "unit-material-albedo-atlas-texture.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Albedo Image Format",
    "file": "unit-material-albedo-image-format.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Albedo Image Import",
    "file": "unit-material-albedo-image-import.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Anisotropy Flowmap",
    "file": "unit-material-anisotropy-flowmap.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Anisotropy",
    "file": "unit-material-anisotropy.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Ao",
    "file": "unit-material-ao.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Billboard Keep Scale",
    "file": "unit-material-billboard-keep-scale.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Billboard",
    "file": "unit-material-billboard.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Clearcoat Layering",
    "file": "unit-material-clearcoat-layering.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Clearcoat",
    "file": "unit-material-clearcoat.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Diffuse Mode",
    "file": "unit-material-diffuse-mode.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Emission Add",
    "file": "unit-material-emission-add.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Emission Hdr",
    "file": "unit-material-emission-hdr.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Emission Texture",
    "file": "unit-material-emission-texture.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Emissive",
    "file": "unit-material-emissive.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Heightmap",
    "file": "unit-material-heightmap.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Metallic",
    "file": "unit-material-metallic.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Mipmap Import",
    "file": "unit-material-mipmap-import.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Next Pass",
    "file": "unit-material-next-pass.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Normal Map Blue",
    "file": "unit-material-normal-map-blue.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Normal Map Uv Density",
    "file": "unit-material-normal-map-uv-density.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Normal Map",
    "file": "unit-material-normal-map.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Override",
    "file": "unit-material-override.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Refraction",
    "file": "unit-material-refraction.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Rim",
    "file": "unit-material-rim.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Roughness Limiter Derivative",
    "file": "unit-material-roughness-limiter-derivative.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Roughness Limiter",
    "file": "unit-material-roughness-limiter.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Specular Mode",
    "file": "unit-material-specular-mode.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Texture Channel",
    "file": "unit-material-texture-channel.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Texture Filter Anisotropic",
    "file": "unit-material-texture-filter-anisotropic.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Texture Filter",
    "file": "unit-material-texture-filter.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Textured",
    "file": "unit-material-textured.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Uv1 Top Edge",
    "file": "unit-material-uv1-top-edge.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Vertex Color Srgb",
    "file": "unit-material-vertex-color-srgb.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material World Triplanar Floor",
    "file": "unit-material-world-triplanar-floor.tscn",
    "category": "Unit - Materials"
  },
  {
    "name": "Material Mipmap Bias Normal",
    "file": "mipmap-bias/unit-material-mipmap-bias-normal.tscn",
    "category": "Unit - Materials",
    "root": "mipmap-bias"
  },
  {
    "name": "Material Mipmap Bias",
    "file": "mipmap-bias/unit-material-mipmap-bias.tscn",
    "category": "Unit - Materials",
    "root": "mipmap-bias"
  },
  {
    "name": "Navigation Agent 2d",
    "file": "unit-navigation-agent-2d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Navigation Agent 3d",
    "file": "unit-navigation-agent-3d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Navigation Link 2d",
    "file": "unit-navigation-link-2d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Navigation Link 3d",
    "file": "unit-navigation-link-3d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Navigation Obstacle 2d",
    "file": "unit-navigation-obstacle-2d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Navigation Obstacle 3d",
    "file": "unit-navigation-obstacle-3d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Navigation Region 2d",
    "file": "unit-navigation-region-2d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Navigation Region 3d",
    "file": "unit-navigation-region-3d.tscn",
    "category": "Unit - Navigation"
  },
  {
    "name": "Sub Viewport 2d Directional Shadow",
    "file": "unit-sub-viewport-2d-directional-shadow.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport 2d Light",
    "file": "unit-sub-viewport-2d-light.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport 3d Canvas Background",
    "file": "unit-sub-viewport-3d-canvas-background.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport 3d Canvas Item",
    "file": "unit-sub-viewport-3d-canvas-item.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport 3d Controls",
    "file": "unit-sub-viewport-3d-controls.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport 3d Keep Background",
    "file": "unit-sub-viewport-3d-keep-background.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Camera 2d Canvas Layer",
    "file": "unit-sub-viewport-camera-2d-canvas-layer.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Camera Environment",
    "file": "unit-sub-viewport-camera-environment.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Camera Exposure",
    "file": "unit-sub-viewport-camera-exposure.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container 2d Content",
    "file": "unit-sub-viewport-container-2d-content.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container 3d Content",
    "file": "unit-sub-viewport-container-3d-content.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Camera 2d",
    "file": "unit-sub-viewport-container-camera-2d.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Centred",
    "file": "unit-sub-viewport-container-centred.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Shrink 2d Content",
    "file": "unit-sub-viewport-container-shrink-2d-content.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Shrink 3d Content",
    "file": "unit-sub-viewport-container-shrink-3d-content.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Stretch 2d Content",
    "file": "unit-sub-viewport-container-stretch-2d-content.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Stretch Shrink Odd",
    "file": "unit-sub-viewport-container-stretch-shrink-odd.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Stretch",
    "file": "unit-sub-viewport-container-stretch.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Translucent 3d Content",
    "file": "unit-sub-viewport-container-translucent-3d-content.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container Translucent",
    "file": "unit-sub-viewport-container-translucent.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Container",
    "file": "unit-sub-viewport-container.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Control Msaa",
    "file": "unit-sub-viewport-control-msaa.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Control Outer Light",
    "file": "unit-sub-viewport-control-outer-light.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Control Texture",
    "file": "unit-sub-viewport-control-texture.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Debanding",
    "file": "unit-sub-viewport-debanding.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Inherited Rtl",
    "file": "unit-sub-viewport-inherited-rtl.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Mixed Controls",
    "file": "unit-sub-viewport-mixed-controls.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Msaa",
    "file": "unit-sub-viewport-msaa.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Own World Glow",
    "file": "unit-sub-viewport-own-world-glow.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Own World Tonemap",
    "file": "unit-sub-viewport-own-world-tonemap.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Own World",
    "file": "unit-sub-viewport-own-world.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Shared Root Camera Environment",
    "file": "unit-sub-viewport-shared-root-camera-environment.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Shared World Camera Environment",
    "file": "unit-sub-viewport-shared-world-camera-environment.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Shared World Camera Exposure",
    "file": "unit-sub-viewport-shared-world-camera-exposure.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Shared World Exposure",
    "file": "unit-sub-viewport-shared-world-exposure.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Shared World Glow",
    "file": "unit-sub-viewport-shared-world-glow.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Shared World Sky Exposure",
    "file": "unit-sub-viewport-shared-world-sky-exposure.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Texture Emission",
    "file": "unit-sub-viewport-texture-emission.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Texture Sampler",
    "file": "unit-sub-viewport-texture-sampler.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport Texture",
    "file": "unit-sub-viewport-texture.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Sub Viewport",
    "file": "unit-sub-viewport.tscn",
    "category": "Unit - Viewports"
  },
  {
    "name": "Bone Pile 1",
    "file": "decorations/bone_pile_1.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Bone Pile 2",
    "file": "decorations/bone_pile_2.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Candle",
    "file": "decorations/candle.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Coin Pile",
    "file": "decorations/coin_pile.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Internal Shadow",
    "file": "decorations/internal_shadow.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Vase 1",
    "file": "decorations/vase_1.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Vase 2",
    "file": "decorations/vase_2.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Dungeon",
    "file": "dungeon.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Goblin",
    "file": "player/goblin.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Candle Preview",
    "file": "previews/candle_preview.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Goblin Preview",
    "file": "previews/goblin_preview.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Internal Shadow Preview",
    "file": "previews/internal_shadow_preview.tscn",
    "category": "Examples - Isometric Dungeon"
  },
  {
    "name": "Bullet Shower (2D)",
    "file": "demos/2d/bullet_shower/shower.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/bullet_shower"
  },
  {
    "name": "Custom Drawing (2D)",
    "file": "demos/2d/custom_drawing/custom_drawing.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/custom_drawing"
  },
  {
    "name": "Dodge The Creeps (2D): hud",
    "file": "demos/2d/dodge_the_creeps/hud.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/dodge_the_creeps"
  },
  {
    "name": "Dodge The Creeps (2D)",
    "file": "demos/2d/dodge_the_creeps/main.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/dodge_the_creeps"
  },
  {
    "name": "Dodge The Creeps (2D): mob",
    "file": "demos/2d/dodge_the_creeps/mob.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/dodge_the_creeps"
  },
  {
    "name": "Dodge The Creeps (2D): player",
    "file": "demos/2d/dodge_the_creeps/player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/dodge_the_creeps"
  },
  {
    "name": "Dynamic Tilemap Layers (2D): player/player",
    "file": "demos/2d/dynamic_tilemap_layers/player/player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/dynamic_tilemap_layers"
  },
  {
    "name": "Dynamic Tilemap Layers (2D)",
    "file": "demos/2d/dynamic_tilemap_layers/world.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/dynamic_tilemap_layers"
  },
  {
    "name": "Finite State Machine (2D)",
    "file": "demos/2d/finite_state_machine/Demo.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/finite_state_machine"
  },
  {
    "name": "Finite State Machine (2D): debug/ControlsPanel",
    "file": "demos/2d/finite_state_machine/debug/ControlsPanel.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/finite_state_machine"
  },
  {
    "name": "Finite State Machine (2D): debug/Explanations",
    "file": "demos/2d/finite_state_machine/debug/Explanations.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/finite_state_machine"
  },
  {
    "name": "Finite State Machine (2D): debug/StatesStackDiplayer",
    "file": "demos/2d/finite_state_machine/debug/StatesStackDiplayer.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/finite_state_machine"
  },
  {
    "name": "Finite State Machine (2D): player/Player",
    "file": "demos/2d/finite_state_machine/player/Player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/finite_state_machine"
  },
  {
    "name": "Finite State Machine (2D): player/bullet/Bullet",
    "file": "demos/2d/finite_state_machine/player/bullet/Bullet.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/finite_state_machine"
  },
  {
    "name": "Finite State Machine (2D): player/weapon/Sword",
    "file": "demos/2d/finite_state_machine/player/weapon/Sword.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/finite_state_machine"
  },
  {
    "name": "Glow (2D)",
    "file": "demos/2d/glow/beach_cave.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/glow"
  },
  {
    "name": "Hexagonal Map (2D)",
    "file": "demos/2d/hexagonal_map/map.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/hexagonal_map"
  },
  {
    "name": "Hexagonal Map (2D): tileset_edit",
    "file": "demos/2d/hexagonal_map/tileset_edit.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/hexagonal_map"
  },
  {
    "name": "Hexagonal Map (2D): troll",
    "file": "demos/2d/hexagonal_map/troll.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/hexagonal_map"
  },
  {
    "name": "Instancing (2D): ball",
    "file": "demos/2d/instancing/ball.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/instancing"
  },
  {
    "name": "Instancing (2D)",
    "file": "demos/2d/instancing/scene_instancing.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/instancing"
  },
  {
    "name": "Kinematic Character (2D): player/player",
    "file": "demos/2d/kinematic_character/player/player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/kinematic_character"
  },
  {
    "name": "Kinematic Character (2D)",
    "file": "demos/2d/kinematic_character/world.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/kinematic_character"
  },
  {
    "name": "Light2d As Mask (2D)",
    "file": "demos/2d/light2d_as_mask/lightmask.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/light2d_as_mask"
  },
  {
    "name": "Lights And Shadows (2D)",
    "file": "demos/2d/lights_and_shadows/light_shadows.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/lights_and_shadows"
  },
  {
    "name": "Navigation (2D): character",
    "file": "demos/2d/navigation/character.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/navigation"
  },
  {
    "name": "Navigation (2D)",
    "file": "demos/2d/navigation/navigation.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/navigation"
  },
  {
    "name": "Navigation Astar (2D)",
    "file": "demos/2d/navigation_astar/game.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/navigation_astar"
  },
  {
    "name": "Navigation Mesh Chunks (2D)",
    "file": "demos/2d/navigation_mesh_chunks/navmesh_chunks_demo_2d.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/navigation_mesh_chunks"
  },
  {
    "name": "Particles (2D)",
    "file": "demos/2d/particles/particles.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/particles"
  },
  {
    "name": "Physics Platformer (2D): background/parallax_bg",
    "file": "demos/2d/physics_platformer/background/parallax_bg.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): background/seesaw",
    "file": "demos/2d/physics_platformer/background/seesaw.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): coin/coin",
    "file": "demos/2d/physics_platformer/coin/coin.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): enemy/enemy",
    "file": "demos/2d/physics_platformer/enemy/enemy.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): platform/moving_platform",
    "file": "demos/2d/physics_platformer/platform/moving_platform.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): platform/one_way_platform",
    "file": "demos/2d/physics_platformer/platform/one_way_platform.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): player/bullet",
    "file": "demos/2d/physics_platformer/player/bullet.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): player/player",
    "file": "demos/2d/physics_platformer/player/player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D)",
    "file": "demos/2d/physics_platformer/stage.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Platformer (2D): tileset_edit",
    "file": "demos/2d/physics_platformer/tileset_edit.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_platformer"
  },
  {
    "name": "Physics Tests (2D)",
    "file": "demos/2d/physics_tests/main.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/dynamic_box",
    "file": "demos/2d/physics_tests/tests/dynamic_box.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_character_pixels",
    "file": "demos/2d/physics_tests/tests/functional/test_character_pixels.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_character_slopes",
    "file": "demos/2d/physics_tests/tests/functional/test_character_slopes.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_character_tilemap",
    "file": "demos/2d/physics_tests/tests/functional/test_character_tilemap.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_collision_pairs",
    "file": "demos/2d/physics_tests/tests/functional/test_collision_pairs.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_joints",
    "file": "demos/2d/physics_tests/tests/functional/test_joints.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_one_way_collision",
    "file": "demos/2d/physics_tests/tests/functional/test_one_way_collision.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_pyramid",
    "file": "demos/2d/physics_tests/tests/functional/test_pyramid.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_raycasting",
    "file": "demos/2d/physics_tests/tests/functional/test_raycasting.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_shapes",
    "file": "demos/2d/physics_tests/tests/functional/test_shapes.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/functional/test_stack",
    "file": "demos/2d/physics_tests/tests/functional/test_stack.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/performance/test_perf_broadphase",
    "file": "demos/2d/physics_tests/tests/performance/test_perf_broadphase.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/performance/test_perf_contact_islands",
    "file": "demos/2d/physics_tests/tests/performance/test_perf_contact_islands.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/performance/test_perf_contacts",
    "file": "demos/2d/physics_tests/tests/performance/test_perf_contacts.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/static_scene",
    "file": "demos/2d/physics_tests/tests/static_scene.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/static_scene_flat",
    "file": "demos/2d/physics_tests/tests/static_scene_flat.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Physics Tests (2D): tests/test_options",
    "file": "demos/2d/physics_tests/tests/test_options.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/physics_tests"
  },
  {
    "name": "Platformer (2D): enemy/enemy",
    "file": "demos/2d/platformer/enemy/enemy.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D)",
    "file": "demos/2d/platformer/game_singleplayer.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): game_splitscreen",
    "file": "demos/2d/platformer/game_splitscreen.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): gui/coins_counter",
    "file": "demos/2d/platformer/gui/coins_counter.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): gui/pause_menu",
    "file": "demos/2d/platformer/gui/pause_menu.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): gui/pause_menu_singleplayer",
    "file": "demos/2d/platformer/gui/pause_menu_singleplayer.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): gui/pause_menu_splitscreen",
    "file": "demos/2d/platformer/gui/pause_menu_splitscreen.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): level/background/parallax_background",
    "file": "demos/2d/platformer/level/background/parallax_background.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): level/coin",
    "file": "demos/2d/platformer/level/coin.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): level/level",
    "file": "demos/2d/platformer/level/level.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): level/platforms/platform",
    "file": "demos/2d/platformer/level/platforms/platform.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): music",
    "file": "demos/2d/platformer/music.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): player/bullet",
    "file": "demos/2d/platformer/player/bullet.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Platformer (2D): player/player",
    "file": "demos/2d/platformer/player/player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/platformer"
  },
  {
    "name": "Polygons Lines (2D)",
    "file": "demos/2d/polygons_lines/polygons_lines.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/polygons_lines"
  },
  {
    "name": "Pong (2D)",
    "file": "demos/2d/pong/pong.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/pong"
  },
  {
    "name": "Role Playing Game (2D): combat/combat",
    "file": "demos/2d/role_playing_game/combat/combat.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): combat/combatants/combatant",
    "file": "demos/2d/role_playing_game/combat/combatants/combatant.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): combat/combatants/health/health",
    "file": "demos/2d/role_playing_game/combat/combatants/health/health.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): combat/combatants/opponent",
    "file": "demos/2d/role_playing_game/combat/combatants/opponent.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): combat/combatants/player",
    "file": "demos/2d/role_playing_game/combat/combatants/player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): combat/combatants/sprites/sprite",
    "file": "demos/2d/role_playing_game/combat/combatants/sprites/sprite.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): combat/interface/info",
    "file": "demos/2d/role_playing_game/combat/interface/info.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): dialogue/dialogue_player/dialogue_player",
    "file": "demos/2d/role_playing_game/dialogue/dialogue_player/dialogue_player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): dialogue/interface/interface",
    "file": "demos/2d/role_playing_game/dialogue/interface/interface.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D)",
    "file": "demos/2d/role_playing_game/game.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): grid_movement/exploration",
    "file": "demos/2d/role_playing_game/grid_movement/exploration.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Role Playing Game (2D): grid_movement/pawns/character",
    "file": "demos/2d/role_playing_game/grid_movement/pawns/character.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/role_playing_game"
  },
  {
    "name": "Screen Space Shaders (2D)",
    "file": "demos/2d/screen_space_shaders/screen_shaders.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/screen_space_shaders"
  },
  {
    "name": "Skeleton (2D)",
    "file": "demos/2d/skeleton/level.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/skeleton"
  },
  {
    "name": "Skeleton (2D): level/parallax_background",
    "file": "demos/2d/skeleton/level/parallax_background.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/skeleton"
  },
  {
    "name": "Skeleton (2D): player/player",
    "file": "demos/2d/skeleton/player/player.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/skeleton"
  },
  {
    "name": "Sprite Shaders (2D)",
    "file": "demos/2d/sprite_shaders/sprite_shaders.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/sprite_shaders"
  },
  {
    "name": "Tween (2D)",
    "file": "demos/2d/tween/main.tscn",
    "category": "Godot Demos - 2D",
    "root": "demos/2d/tween"
  },
  {
    "name": "Antialiasing (3D)",
    "file": "demos/3d/antialiasing/anti_aliasing.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/antialiasing"
  },
  {
    "name": "Antialiasing (3D): thin_lines",
    "file": "demos/3d/antialiasing/thin_lines.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/antialiasing"
  },
  {
    "name": "Csg (3D)",
    "file": "demos/3d/csg/csg.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/csg"
  },
  {
    "name": "Decals (3D): decal",
    "file": "demos/3d/decals/decal.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/decals"
  },
  {
    "name": "Decals (3D)",
    "file": "demos/3d/decals/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/decals"
  },
  {
    "name": "Global Illumination (3D)",
    "file": "demos/3d/global_illumination/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/global_illumination"
  },
  {
    "name": "Graphics Settings (3D): 3d_scene",
    "file": "demos/3d/graphics_settings/3d_scene.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/graphics_settings"
  },
  {
    "name": "Graphics Settings (3D)",
    "file": "demos/3d/graphics_settings/control.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/graphics_settings"
  },
  {
    "name": "Ik (3D): fabrik_ik",
    "file": "demos/3d/ik/fabrik_ik.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/ik"
  },
  {
    "name": "Ik (3D): fps/fps_example",
    "file": "demos/3d/ik/fps/fps_example.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/ik"
  },
  {
    "name": "Ik (3D): fps/simple_bullet",
    "file": "demos/3d/ik/fps/simple_bullet.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/ik"
  },
  {
    "name": "Ik (3D)",
    "file": "demos/3d/ik/look_at_ik.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/ik"
  },
  {
    "name": "Ik (3D): skeleton_ik",
    "file": "demos/3d/ik/skeleton_ik.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/ik"
  },
  {
    "name": "Kinematic Character (3D)",
    "file": "demos/3d/kinematic_character/level.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/kinematic_character"
  },
  {
    "name": "Kinematic Character (3D): player/cubio",
    "file": "demos/3d/kinematic_character/player/cubio.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/kinematic_character"
  },
  {
    "name": "Labels And Texts (3D)",
    "file": "demos/3d/labels_and_texts/3d_labels_and_texts.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/labels_and_texts"
  },
  {
    "name": "Lights And Shadows (3D)",
    "file": "demos/3d/lights_and_shadows/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/lights_and_shadows"
  },
  {
    "name": "Material Testers (3D)",
    "file": "demos/3d/material_testers/material_tester.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/material_testers"
  },
  {
    "name": "Material Testers (3D): models/test_bed/test_bed",
    "file": "demos/3d/material_testers/models/test_bed/test_bed.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/material_testers"
  },
  {
    "name": "Navigation (3D)",
    "file": "demos/3d/navigation/navmesh.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/navigation"
  },
  {
    "name": "Navigation Mesh Chunks (3D)",
    "file": "demos/3d/navigation_mesh_chunks/navmesh_chhunks_demo_3d.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/navigation_mesh_chunks"
  },
  {
    "name": "Occlusion Culling Mesh Lod (3D): door",
    "file": "demos/3d/occlusion_culling_mesh_lod/door.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/occlusion_culling_mesh_lod"
  },
  {
    "name": "Occlusion Culling Mesh Lod (3D)",
    "file": "demos/3d/occlusion_culling_mesh_lod/node_3d.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/occlusion_culling_mesh_lod"
  },
  {
    "name": "Particles (3D)",
    "file": "demos/3d/particles/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/particles"
  },
  {
    "name": "Physical Light Camera Units (3D)",
    "file": "demos/3d/physical_light_camera_units/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physical_light_camera_units"
  },
  {
    "name": "Physics Interpolation (3D)",
    "file": "demos/3d/physics_interpolation/box.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_interpolation"
  },
  {
    "name": "Physics Interpolation (3D): bullet",
    "file": "demos/3d/physics_interpolation/bullet.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_interpolation"
  },
  {
    "name": "Physics Interpolation (3D): root",
    "file": "demos/3d/physics_interpolation/root.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_interpolation"
  },
  {
    "name": "Physics Interpolation (3D): wall",
    "file": "demos/3d/physics_interpolation/wall.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_interpolation"
  },
  {
    "name": "Physics Tests (3D)",
    "file": "demos/3d/physics_tests/main.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_collision_pairs",
    "file": "demos/3d/physics_tests/tests/functional/test_collision_pairs.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_compound_shapes",
    "file": "demos/3d/physics_tests/tests/functional/test_compound_shapes.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_friction",
    "file": "demos/3d/physics_tests/tests/functional/test_friction.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_joints",
    "file": "demos/3d/physics_tests/tests/functional/test_joints.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_moving_platform",
    "file": "demos/3d/physics_tests/tests/functional/test_moving_platform.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_pyramid",
    "file": "demos/3d/physics_tests/tests/functional/test_pyramid.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_raycasting",
    "file": "demos/3d/physics_tests/tests/functional/test_raycasting.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_rigidbody_ground_check",
    "file": "demos/3d/physics_tests/tests/functional/test_rigidbody_ground_check.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_rigidbody_impact",
    "file": "demos/3d/physics_tests/tests/functional/test_rigidbody_impact.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_shapes",
    "file": "demos/3d/physics_tests/tests/functional/test_shapes.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/functional/test_stack",
    "file": "demos/3d/physics_tests/tests/functional/test_stack.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/performance/test_perf_broadphase",
    "file": "demos/3d/physics_tests/tests/performance/test_perf_broadphase.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/performance/test_perf_contact_islands",
    "file": "demos/3d/physics_tests/tests/performance/test_perf_contact_islands.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/performance/test_perf_contacts",
    "file": "demos/3d/physics_tests/tests/performance/test_perf_contacts.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/static_scene",
    "file": "demos/3d/physics_tests/tests/static_scene.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/static_scene_plane",
    "file": "demos/3d/physics_tests/tests/static_scene_plane.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Physics Tests (3D): tests/test_options",
    "file": "demos/3d/physics_tests/tests/test_options.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/physics_tests"
  },
  {
    "name": "Platformer (3D): coin/coin",
    "file": "demos/3d/platformer/coin/coin.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D): enemy/enemy",
    "file": "demos/3d/platformer/enemy/enemy.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D)",
    "file": "demos/3d/platformer/game.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D): player/bullet/bullet",
    "file": "demos/3d/platformer/player/bullet/bullet.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D): player/player",
    "file": "demos/3d/platformer/player/player.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D): stage/grid_map",
    "file": "demos/3d/platformer/stage/grid_map.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D): stage/stage",
    "file": "demos/3d/platformer/stage/stage.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D): touch_screen_ui/touch_screen_ui",
    "file": "demos/3d/platformer/touch_screen_ui/touch_screen_ui.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Platformer (3D): touch_screen_ui/virtual_joystick/virtual_joystick_scene",
    "file": "demos/3d/platformer/touch_screen_ui/virtual_joystick/virtual_joystick_scene.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/platformer"
  },
  {
    "name": "Procedural Materials (3D)",
    "file": "demos/3d/procedural_materials/loading.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/procedural_materials"
  },
  {
    "name": "Procedural Materials (3D): test",
    "file": "demos/3d/procedural_materials/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/procedural_materials"
  },
  {
    "name": "Ragdoll Physics (3D)",
    "file": "demos/3d/ragdoll_physics/characters/mannequiny_ragdoll.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/ragdoll_physics"
  },
  {
    "name": "Ragdoll Physics (3D): ragdoll_physics",
    "file": "demos/3d/ragdoll_physics/ragdoll_physics.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/ragdoll_physics"
  },
  {
    "name": "Rigidbody Character (3D): cube_rigidbody",
    "file": "demos/3d/rigidbody_character/cube_rigidbody.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/rigidbody_character"
  },
  {
    "name": "Rigidbody Character (3D)",
    "file": "demos/3d/rigidbody_character/level.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/rigidbody_character"
  },
  {
    "name": "Rigidbody Character (3D): player/cubio",
    "file": "demos/3d/rigidbody_character/player/cubio.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/rigidbody_character"
  },
  {
    "name": "Sky Shaders (3D)",
    "file": "demos/3d/sky_shaders/Main.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/sky_shaders"
  },
  {
    "name": "Soft Body Physics (3D): box",
    "file": "demos/3d/soft_body_physics/box.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/soft_body_physics"
  },
  {
    "name": "Soft Body Physics (3D): cloth",
    "file": "demos/3d/soft_body_physics/cloth.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/soft_body_physics"
  },
  {
    "name": "Soft Body Physics (3D): pin",
    "file": "demos/3d/soft_body_physics/pin.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/soft_body_physics"
  },
  {
    "name": "Soft Body Physics (3D): rigid_box_heavy",
    "file": "demos/3d/soft_body_physics/rigid_box_heavy.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/soft_body_physics"
  },
  {
    "name": "Soft Body Physics (3D): rigid_box_light",
    "file": "demos/3d/soft_body_physics/rigid_box_light.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/soft_body_physics"
  },
  {
    "name": "Soft Body Physics (3D): sphere",
    "file": "demos/3d/soft_body_physics/sphere.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/soft_body_physics"
  },
  {
    "name": "Soft Body Physics (3D)",
    "file": "demos/3d/soft_body_physics/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/soft_body_physics"
  },
  {
    "name": "Sprites (3D)",
    "file": "demos/3d/sprites/3d_sprites.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/sprites"
  },
  {
    "name": "Sprites (3D): player/player",
    "file": "demos/3d/sprites/player/player.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/sprites"
  },
  {
    "name": "Squash The Creeps (3D)",
    "file": "demos/3d/squash_the_creeps/Main.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/squash_the_creeps"
  },
  {
    "name": "Squash The Creeps (3D): Mob",
    "file": "demos/3d/squash_the_creeps/Mob.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/squash_the_creeps"
  },
  {
    "name": "Squash The Creeps (3D): MusicPlayer",
    "file": "demos/3d/squash_the_creeps/MusicPlayer.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/squash_the_creeps"
  },
  {
    "name": "Squash The Creeps (3D): Player",
    "file": "demos/3d/squash_the_creeps/Player.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/squash_the_creeps"
  },
  {
    "name": "Tonemap Color Correction (3D): 3d_primitives",
    "file": "demos/3d/tonemap_color_correction/3d_primitives.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/tonemap_color_correction"
  },
  {
    "name": "Tonemap Color Correction (3D): gradients",
    "file": "demos/3d/tonemap_color_correction/gradients.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/tonemap_color_correction"
  },
  {
    "name": "Tonemap Color Correction (3D): gradients/gradient_bars",
    "file": "demos/3d/tonemap_color_correction/gradients/gradient_bars.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/tonemap_color_correction"
  },
  {
    "name": "Tonemap Color Correction (3D): hues",
    "file": "demos/3d/tonemap_color_correction/hues.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/tonemap_color_correction"
  },
  {
    "name": "Tonemap Color Correction (3D)",
    "file": "demos/3d/tonemap_color_correction/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/tonemap_color_correction"
  },
  {
    "name": "Truck Town (3D)",
    "file": "demos/3d/truck_town/car_select/car_select.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/truck_town"
  },
  {
    "name": "Truck Town (3D): town/lamp/lamp_scene",
    "file": "demos/3d/truck_town/town/lamp/lamp_scene.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/truck_town"
  },
  {
    "name": "Truck Town (3D): town/model/racetrack_csg",
    "file": "demos/3d/truck_town/town/model/racetrack_csg.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/truck_town"
  },
  {
    "name": "Truck Town (3D): town/town_scene",
    "file": "demos/3d/truck_town/town/town_scene.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/truck_town"
  },
  {
    "name": "Truck Town (3D): vehicles/car_base",
    "file": "demos/3d/truck_town/vehicles/car_base.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/truck_town"
  },
  {
    "name": "Truck Town (3D): vehicles/tow_truck",
    "file": "demos/3d/truck_town/vehicles/tow_truck.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/truck_town"
  },
  {
    "name": "Truck Town (3D): vehicles/trailer_truck",
    "file": "demos/3d/truck_town/vehicles/trailer_truck.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/truck_town"
  },
  {
    "name": "Variable Rate Shading (3D)",
    "file": "demos/3d/variable_rate_shading/vrs.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/variable_rate_shading"
  },
  {
    "name": "Visibility Ranges (3D)",
    "file": "demos/3d/visibility_ranges/test.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/visibility_ranges"
  },
  {
    "name": "Visibility Ranges (3D): tree",
    "file": "demos/3d/visibility_ranges/tree.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/visibility_ranges"
  },
  {
    "name": "Visibility Ranges (3D): tree_cluster",
    "file": "demos/3d/visibility_ranges/tree_cluster.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/visibility_ranges"
  },
  {
    "name": "Volumetric Fog (3D)",
    "file": "demos/3d/volumetric_fog/volumetric_fog.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/volumetric_fog"
  },
  {
    "name": "Voxel (3D): menu/ingame/pause_menu",
    "file": "demos/3d/voxel/menu/ingame/pause_menu.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/voxel"
  },
  {
    "name": "Voxel (3D)",
    "file": "demos/3d/voxel/menu/main/main_menu.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/voxel"
  },
  {
    "name": "Voxel (3D): menu/options/options",
    "file": "demos/3d/voxel/menu/options/options.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/voxel"
  },
  {
    "name": "Voxel (3D): player/player",
    "file": "demos/3d/voxel/player/player.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/voxel"
  },
  {
    "name": "Voxel (3D): world/world",
    "file": "demos/3d/voxel/world/world.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/voxel"
  },
  {
    "name": "Waypoints (3D)",
    "file": "demos/3d/waypoints/main.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/waypoints"
  },
  {
    "name": "Waypoints (3D): waypoint",
    "file": "demos/3d/waypoints/waypoint.tscn",
    "category": "Godot Demos - 3D",
    "root": "demos/3d/waypoints"
  },
  {
    "name": "Accessibility (GUI)",
    "file": "demos/gui/accessibility/controls.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/accessibility"
  },
  {
    "name": "Bidi And Font Features (GUI)",
    "file": "demos/gui/bidi_and_font_features/bidi.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/bidi_and_font_features"
  },
  {
    "name": "Control Gallery (GUI)",
    "file": "demos/gui/control_gallery/control_gallery.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/control_gallery"
  },
  {
    "name": "Drag And Drop (GUI)",
    "file": "demos/gui/drag_and_drop/drag_and_drop.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/drag_and_drop"
  },
  {
    "name": "Gd Paint (GUI)",
    "file": "demos/gui/gd_paint/paint_root.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/gd_paint"
  },
  {
    "name": "Input Mapping (GUI): ActionRemapButton",
    "file": "demos/gui/input_mapping/ActionRemapButton.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/input_mapping"
  },
  {
    "name": "Input Mapping (GUI)",
    "file": "demos/gui/input_mapping/InputRemapMenu.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/input_mapping"
  },
  {
    "name": "Msdf Font (GUI)",
    "file": "demos/gui/msdf_font/sdf_font_demo.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/msdf_font"
  },
  {
    "name": "Multiple Resolutions (GUI)",
    "file": "demos/gui/multiple_resolutions/main.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/multiple_resolutions"
  },
  {
    "name": "Pseudolocalization (GUI)",
    "file": "demos/gui/pseudolocalization/Pseudolocalization.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/pseudolocalization"
  },
  {
    "name": "Regex (GUI)",
    "file": "demos/gui/regex/regex.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/regex"
  },
  {
    "name": "Rich Text Bbcode (GUI)",
    "file": "demos/gui/rich_text_bbcode/rich_text_bbcode.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/rich_text_bbcode"
  },
  {
    "name": "Theming Override (GUI)",
    "file": "demos/gui/theming_override/test.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/theming_override"
  },
  {
    "name": "Translation (GUI)",
    "file": "demos/gui/translation/translation_demo_csv.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/translation"
  },
  {
    "name": "Translation (GUI): translation_demo_po",
    "file": "demos/gui/translation/translation_demo_po.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/translation"
  },
  {
    "name": "Ui Mirroring (GUI)",
    "file": "demos/gui/ui_mirroring/ui_mirroring.tscn",
    "category": "Godot Demos - GUI",
    "root": "demos/gui/ui_mirroring"
  },
  {
    "name": "2d In 3d (Viewport)",
    "file": "demos/viewport/2d_in_3d/2d_in_3d.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/2d_in_3d"
  },
  {
    "name": "3d In 2d (Viewport)",
    "file": "demos/viewport/3d_in_2d/3d_in_2d.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/3d_in_2d"
  },
  {
    "name": "3d In 2d (Viewport): robot_3d",
    "file": "demos/viewport/3d_in_2d/robot_3d.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/3d_in_2d"
  },
  {
    "name": "3d Scaling (Viewport): cubes",
    "file": "demos/viewport/3d_scaling/cubes.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/3d_scaling"
  },
  {
    "name": "3d Scaling (Viewport)",
    "file": "demos/viewport/3d_scaling/hud.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/3d_scaling"
  },
  {
    "name": "Dynamic Split Screen (Viewport)",
    "file": "demos/viewport/dynamic_split_screen/split_screen.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/dynamic_split_screen"
  },
  {
    "name": "Gui In 3d (Viewport)",
    "file": "demos/viewport/gui_in_3d/gui_in_3d.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/gui_in_3d"
  },
  {
    "name": "Gui In 3d (Viewport): gui_panel_3d",
    "file": "demos/viewport/gui_in_3d/gui_panel_3d.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/gui_in_3d"
  },
  {
    "name": "Screen Capture (Viewport)",
    "file": "demos/viewport/screen_capture/screen_capture.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/screen_capture"
  },
  {
    "name": "Split Screen Input (Viewport): split_screen",
    "file": "demos/viewport/split_screen_input/split_screen.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/split_screen_input"
  },
  {
    "name": "Split Screen Input (Viewport)",
    "file": "demos/viewport/split_screen_input/split_screen_demo.tscn",
    "category": "Godot Demos - Viewport",
    "root": "demos/viewport/split_screen_input"
  }
];

export function getFixturesByCategory(): Map<string, Fixture[]> {
  const categorized = new Map<string, Fixture[]>();

  for (const fixture of fixtures) {
    const category = fixture.category;
    if (!categorized.has(category)) {
      categorized.set(category, []);
    }
    categorized.get(category)!.push(fixture);
  }

  return categorized;
}
